// import React, { useContext, useEffect, useRef, useState } from "react";
// import "./workorder.css";
// import Application from "../../../StateContext/Application.js";
// import { apiurl } from "../../../../../path.js";
// import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
// import * as exifr from "exifr";

// const CreateWorkOrder = () => {
//     const isSubmittingRef = useRef(false);
//     const { language, toggleLanguage, t } = useLanguage();
//     const operation = useContext(Application);
//     const { GetProjectInfo, GetBudgetHeadInfo, WorkOrderCreation } = operation;
//     const [projectId, setProjectId] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [HeadId, setHeadID] = useState([]);
//     const [relatedHeadID, setRelatedHeadID] = useState([]);
//     const [Contractor, setContractor] = useState([]);
//     const [HeadCode, setHeadCode] = useState([]);
//     const [FetchedFData, setFetchedFData] = useState([]);
//     const [taluka, setTaluka] = useState([]);
//     const [GrnData, setGrnData] = useState([]);
//     const [ProposalID, setProposalID] = useState([]);
//     const [proposalcost, setProposalCost] = useState("0");
//     const [OriginalRemaining, setOriginalRemaining] = useState("0");
//     const [ProposalRemaingAmount, setProposalRemainigAmount] = useState("0");
//     const [TechnicalSanctionUid, setTechnicalSanctionUid] = useState([]);
//     const [selectedProposals, setSelectedProposals] = useState([]);
//     const [panError, setPanError] = useState("");
//     const [TotalSelectedProposalCost, setTotalSelectedProposalCost] = useState(0);
//     const [usedMHUIDs, setUsedMHUIDs] = useState([]);
//     const [processedProposalCopy, setProcessedProposalCopy] = useState(null);
//     const [fileProcessing, setFileProcessing] = useState(false);

//     const [data, setData] = useState({
//         HeadCode: "",
//         ProposalYear: "",
//         talulka: "",
//         GrID: "",
//         ProposalId: "",
//         PanNo: "NA",
//         ContractorName: "",
//         WorkName: " ",
//         WorkOrderNo: null,
//         WorkOrderDate: null,
//         WorkEndDate: null,
//         ProposalCost: "0",
//         RemainingProposalCost: "0",
//         ApprovedWorkAmount: "0",
//         PaidAmount: "0",
//         CompletedProgress: "",
//         RemainingAmount: "0",
//         fillingForm: "second",
//         OriginalRemainingAmount: "0",
//         OriginalPaidAmount: "0",
//         TechnicalSanctionUID: "",
//     });

//     const HandleChangeData = (e) => {
//         const { name, value } = e.target;
//         if (value.length === 1 && value[0] === " ") return;

//         // Prevent negative numbers for numeric inputs (existing behaviour)
//         if (
//             name === "ApprovedWorkAmount" ||
//             name === "PaidAmount"
//         ) {
//             const number = parseFloat(value);
//             if (!isNaN(number) && number < 0) return;
//         }

//         // Define the hierarchy/order of fields in the form.
//         const order = [
//             "HeadCode",
//             "ProposalYear",
//             "talulka",
//             "TechnicalSanctionUID",
//             "ProposalId",
//             "ContractorName",
//             "WorkName",
//             "WorkOrderNo",
//             "WorkOrderDate",
//             "WorkEndDate",
//             "TotalSelectedProposalCost",
//             "ApprovedWorkAmount",
//             "CompletedProgress",
//             "PaidAmount",
//             "RemainingAmount",
//             "CopyOfWorkOrder",
//         ];

//         // Helper to reset fields that come *after* the changed field in the order
//         const resetBelow = (field) => {
//             const idx = order.indexOf(field);
//             if (idx === -1) return;

//             // Build partial update for `data`
//             const resetData = { ...data };
//             setData(resetData);
//             // For each field after the changed one, reset sensible defaults
//             for (let i = idx + 1; i < order.length; i++) {
//                 const f = order[i];
//                 switch (f) {
//                     case "ProposalYear":
//                     case "HeadCode":
//                     case "talulka":
//                     case "TechnicalSanctionUID":
//                     case "ProposalId":
//                     case "WorkName":
//                     case "WorkOrderNo":
//                         resetData[f] = "";
//                         break;
//                     case "CompletedProgress":
//                         resetData[f] = "NA";
//                         break;
//                     // FIX: Instead of resetting to "", set it to the current total from the table
//                     case "ApprovedWorkAmount":
//                         resetData[f] = TotalSelectedProposalCost;
//                         break;
//                     case "RemainingAmount":
//                         resetData[f] = Math.max(TotalSelectedProposalCost - (Number(resetData.PaidAmount) || 0), 0);
//                         break;
//                     case "CopyOfWorkOrder":
//                         break;
//                     default:
//                         resetData[f] = "";
//                 }
//             }

//             // Apply targeted resets to other pieces of component state that depend on earlier fields
//             // If any of the fields before/including ProposalId were changed, the list of proposals, taluka,
//             // technical sanctions and selectedProposals should be cleared (so old options don't leak).
//             const clearProposalRelated = [
//                 "HeadCode",
//                 "ProposalYear",
//                 "talulka",
//                 "TechnicalSanctionUID",
//                 "ProposalId",
//             ].some((f) => f === field || order.indexOf(f) < order.indexOf(field));

//             // But we want to clear selected proposals when any of the FIRST five fields change
//             if (
//                 [
//                     "HeadCode",
//                     "ProposalYear",
//                     "talulka",
//                     "TechnicalSanctionUID",
//                     "ProposalId",
//                 ].includes(field)
//             ) {
//                 setSelectedProposals([]);
//                 setTotalSelectedProposalCost(0);
//             }

//             // If head or year changed, also clear taluka/proposals lists and technical uid list
//             if (field === "HeadCode") {
//                 setTaluka([]);
//                 setFetchedFData([]);
//                 setProposalID([]);
//                 setTechnicalSanctionUid([]);
//             }
//             if (field === "ProposalYear") {
//                 setProposalID([]);
//                 setTechnicalSanctionUid([]);
//             }
//             if (field === "talulka") {
//                 setTechnicalSanctionUid([]);
//                 setProposalID([]);
//             }
//             if (field === "TechnicalSanctionUID") {
//                 setProposalID([]);
//                 // setData(data.ContractorName)
//             }
//             if (field === "ProposalId") {
//                 // Proposal changed — clear previously added works (they belong to previous proposal)
//                 setSelectedProposals([]);
//                 // setTotalSelectedProposalCost(0);
//             }

//             // Clear processed file if user changed anything above CopyOfWorkOrder
//             if (
//                 [
//                     "HeadCode",
//                     "ProposalYear",
//                     "talulka",
//                     "TechnicalSanctionUID",
//                     "ProposalId",
//                     "WorkName",
//                     "WorkOrderNo",
//                 ].includes(field)
//             ) {
//                 setProcessedProposalCopy(null);
//             }

//             // Finally set data state with resets already applied (we will override the changed field below)
//             setData(resetData);
//         };

//         // Execute resets for fields that need to clear downstream values
//         resetBelow(name);

//         // Now set the changed field value (after resets)
//         // Use functional update to avoid stale state race
//         setData((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     // paste this in CreateWorkOrder.js replacing the current handleSubmit
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // 🚫 HARD BLOCK (instant, no re-render needed)
//         if (isSubmittingRef.current) return;

//         // ---------------- VALIDATIONS ----------------
//         const requiredFields = [
//             { name: "HeadCode", label: "Head Code" },
//             { name: "ProposalYear", label: "Approved Year" },
//             { name: "talulka", label: "Zilla Parishad" },
//             { name: "TechnicalSanctionUID", label: "MHUID Number" },
//             { name: "WorkOrderDate", label: "Work Order Date" },
//             { name: "WorkEndDate", label: "Work End Date" },
//             { name: "WorkOrderNo", label: "Work Order No" },
//             { name: "ContractorName", label: "Vendor Name" },
//             { name: "ApprovedWorkAmount", label: "Approved Work Amount" }
//         ];

//         for (const field of requiredFields) {
//             const val = data?.[field.name];
//             if (!val || String(val).trim() === "") {
//                 alert(`${field.label} is required!`);
//                 return;
//             }
//         }

//         if (!selectedProposals || selectedProposals.length === 0) {
//             alert("Please add at least one proposal before submitting!");
//             return;
//         }

//         const CopyOfWorkOrderFiles =
//             document.getElementById("CopyOfWorkOrder")?.files;

//         if (
//             !processedProposalCopy &&
//             (!CopyOfWorkOrderFiles || CopyOfWorkOrderFiles.length === 0)
//         ) {
//             alert("Insert Copy of Work Order (required).");
//             return;
//         }

//         const approvedAmount = Number(data.ApprovedWorkAmount);
//         if (!approvedAmount || approvedAmount <= 0) {
//             alert("Approved Work Amount must be greater than 0.");
//             return;
//         }

//         if (data.PaidAmount && Number(data.PaidAmount) > approvedAmount) {
//             alert("Paid Amount can't be more than Approved Work Amount.");
//             return;
//         }

//         // 🔒 LOCK IMMEDIATELY
//         isSubmittingRef.current = true;
//         setLoading(true);

//         try {
//             const formData = new FormData();

//             let OriginalRemainingProposalCost = Number(data.RemainingProposalCost || 0);
//             let remainingProposalCost =
//                 OriginalRemainingProposalCost - approvedAmount;

//             const approved = Number(data.ApprovedWorkAmount || 0);
//             const paid = Number(data.PaidAmount || 0);
//             const remaining = approved - paid;

//             const updatedData = {
//                 ...data,
//                 RemainingAmount: remaining,
//                 ProposalCost: proposalcost,
//                 RemainingProposalCost:
//                     data.fillingForm === "first"
//                         ? remainingProposalCost
//                         : OriginalRemainingProposalCost,
//             };

//             let finalProposalCopy;
//             try {
//                 finalProposalCopy = processedProposalCopy
//                     ? processedProposalCopy
//                     : await processFile(CopyOfWorkOrderFiles[0]);
//             } catch {
//                 alert("File processing failed");
//                 return;
//             }

//             for (const key in updatedData) {
//                 formData.append(key, updatedData[key]);
//             }

//             formData.append(
//                 "SelectedProposals",
//                 JSON.stringify(selectedProposals)
//             );
//             formData.append("CopyOfWorkOrder", finalProposalCopy);

//             const result = await WorkOrderCreation(formData);

//             alert(result?.message || "Work Order Created Successfully");

//             // 🚀 HARD REDIRECT (no second submit possible)
//             window.location.replace(window.location.href);

//         } catch (error) {
//             console.error(error);
//             alert("Submission failed. Please try again.");
//         } finally {
//             setLoading(false);
//             isSubmittingRef.current = false; // safety
//         }
//     };

//     const FetchData = async () => {
//         setLoading(true);
//         try {
//             let res = await GetProjectInfo("null", "all");
//             let res2 = await GetProjectInfo("null", "Contractor");
//             let res1 = await GetBudgetHeadInfo("null", "all");
//             let res3 = await GetBudgetHeadInfo("null", "AllHeadCode");
//             console.log("res3", res3);
//             console.log("res2", res2);
//             console.log("re1", res1);

//             setProjectId(res);
//             setHeadID(res1);
//             setContractor(res2);
//             setHeadCode(res3);
//         } catch (err) {
//             console.log(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const FetchDataRelatedtoZilla = async (id) => {
//         try {
//             let res = await GetBudgetHeadInfo(
//                 id,
//                 "GetSpecificTalukaDatabasedonHeadcode"
//             );
//             console.log("resss", res);

//             // Ensure it's an array
//             const dataArray = Array.isArray(res) ? res : [];
//             setFetchedFData(dataArray);

//             const uniqueTalukas = [
//                 ...new Set(dataArray.map((item) => item.ZillaParishad)),
//             ];
//             setTaluka(uniqueTalukas);
//         } catch (err) {
//             console.log(err);
//             setFetchedFData([]);
//         }
//     };

//     const sortDatabyProposalYear = (year) => {
//         if (data.HeadCode) {
//             let res = FetchedFData.filter((item) => item.ProposalYear == year);
//             const uniqueTalukas = [...new Set(res.map((item) => item.ZillaParishad))];
//             // setTaluka(uniqueTalukas);
//         }
//     };
//     useEffect(() => {
//         const fetchUsedMHUIDs = async () => {
//             try {
//                 let res = await GetBudgetHeadInfo("null", "CheckMHUIDInWorkOrder");
//                 console.log("Used MHUIDs from API:", res);
//                 setUsedMHUIDs(Array.isArray(res) ? res : []);
//             } catch (err) {
//                 console.log("Error fetching used MHUIDs:", err);
//                 setUsedMHUIDs([]);
//             }
//         };
//         fetchUsedMHUIDs();
//     }, []);

//     // Re-filter TechnicalSanctionUid when usedMHUIDs or FetchedFData changes
//     useEffect(() => {
//         if (
//             data.talulka &&
//             data.HeadCode &&
//             data.ProposalYear &&
//             usedMHUIDs.length > 0
//         ) {
//             sortDataByZilla(data.talulka);
//         }
//     }, [usedMHUIDs, FetchedFData]);

//     const sortDataByZilla = (zilla) => {
//         if (data.HeadCode && data.ProposalYear) {
//             let res = FetchedFData.filter(
//                 (item) =>
//                     item.ZillaParishad == zilla && item.ProposalYear === data.ProposalYear
//             );

//             console.log("Filtered by Zilla:", res);
//             console.log("Used MHUIDs:", usedMHUIDs);

//             const uniqueTechnicalData = res.reduce((acc, curr) => {
//                 // Check if this MHUID is already used in work order
//                 const isUsed = usedMHUIDs.includes(curr.TechnicalSanctionNo);

//                 console.log(`MHUID: ${curr.TechnicalSanctionNo}, isUsed: ${isUsed}`);

//                 // Only add if NOT already in array, has TechnicalSanctionNo, and NOT used
//                 if (
//                     !acc.find((item) => item.TS_ID === curr.TS_ID) &&
//                     curr.TechnicalSanctionNo &&
//                     !isUsed
//                 ) {
//                     acc.push({
//                         TS_ID: curr.TS_ID,
//                         TechnicalSanctionNo: curr.TechnicalSanctionNo,
//                     });
//                 }
//                 return acc;
//             }, []);

//             console.log("Unused MHUIDs for dropdown:", uniqueTechnicalData);
//             setTechnicalSanctionUid(uniqueTechnicalData);
//         }
//     };
//     const sortDataByGrnID = (id) => {
//         console.log(id);
//         if (data.HeadCode && data.ProposalYear && data.talulka) {
//             let res = FetchedFData.filter(
//                 (item) =>
//                     item.GRID == id &&
//                     item.ZillaParishad == data.talulka &&
//                     item.ProposalYear === data.ProposalYear
//             );
//             const uniqueProposalData = res.reduce((acc, curr) => {
//                 if (!acc.find((item) => item.ProposalID === curr.ProposalID)) {
//                     acc.push({
//                         ProposalID: curr.ProposalID,
//                         ProposalName: curr.Work_name,
//                     });
//                 }
//                 return acc;
//             }, []);
//             setProposalID(uniqueProposalData);
//         }
//     };

//     const SortProposalAmountByProposalID = async (id) => {
//         console.log("proposalID", id);
//         try {
//             if (data.HeadCode && data.ProposalYear && data.talulka) {
//                 let res1 = FetchedFData.filter((item) => item.Work_name == id);
//                 console.log(" Proposal Detail ----> ", res1);

//                 if (res1.length > 0) {
//                     console.log("Gram Panchayat :: ", res1[0].Gram_panchayat);
//                 }

//                 setData({
//                     ...data,
//                     ProposalCost: res1[0].ProposalAmount,
//                     GrID: res1[0].GRID,
//                 });
//                 setProposalCost(res1[0].TotalProposalAmount);
//             }
//         } catch (err) {
//             console.log(err);
//             alert(err);
//         }
//     };

//     useEffect(() => {
//         if (data.ProposalId) {
//             SortProposalAmountByProposalID(data.ProposalId);
//         }
//     }, [data.ProposalId]);

//     const handleAddProposal = () => {
//         if (!data.ProposalId || !data.ProposalCost || !data.TechnicalSanctionUID) {
//             alert(
//                 "Please select all above fields."
//             );
//             return;
//         }

//         const newEntry = {
//             GRID: data.GrID,
//             ProposalName: data.ProposalId,
//             ProposalCost: data.ProposalCost,
//             RemainingProposalCost: data.RemainingProposalCost,
//             TechnicalSanctionUID: data.TechnicalSanctionUID,
//         };

//         // prevent duplicates
//         const alreadyAdded = selectedProposals.some(
//             (p) => p.ProposalName === newEntry.ProposalName
//         );

//         if (alreadyAdded) {
//             alert("This Work Name is already added!");
//             return;
//         }

//         const updatedList = [...selectedProposals, newEntry];
//         setSelectedProposals(updatedList);

//         const total = updatedList.reduce(
//             (sum, item) => sum + parseFloat(parseFloat(item.ProposalCost) || 0),
//             0
//         );
//         setTotalSelectedProposalCost(total);
//         setData({
//             ...data,
//             ApprovedWorkAmount: total,
//         });
//     };

//     // 🗑️ Remove proposal from table
//     const handleRemoveProposal = (index) => {
//         const updated = selectedProposals.filter((_, i) => i !== index);
//         setSelectedProposals(updated);
//         const total = updated.reduce(
//             (sum, item) => sum + parseFloat(parseFloat(item.ProposalCost) || 0),
//             0
//         );
//         setTotalSelectedProposalCost(total);
//     };

//     const SortAMountsByVendor = (vendor) => {
//         setData((prev) => ({
//             ...prev,
//             ContractorName: vendor
//         }));
//     };

//     const SortAMountsByWorkName = async (id) => {

//         if (id.length === 1 && id[0] === " ") return;
//         // console.log("dsdfsdf",id);
//         try {
//             if (
//                 data.HeadCode &&
//                 data.ProposalYear &&
//                 data.talulka &&
//                 data.ProposalId &&
//                 data.ContractorName
//             ) {
//                 let obj = {
//                     ContractorName: data.ContractorName,
//                     ProposalID: data.ProposalId,
//                     WorkName: id,
//                 };
//                 let res = await GetBudgetHeadInfo(
//                     obj,
//                     "GetBillPaidRemainingWorkAmount"
//                 );
//                 const { result, status } = res;

//                 console.log("Data i get from Backendst :: ", res, status);

//                 const {
//                     PaidAmount,
//                     RemainingAmount,
//                     RemainingProjectAmount,
//                     OriginalPaidAmount,
//                     OriginalRemainingAmount,
//                 } = result[0];

//                 let RemainingAmountUpdated = parseFloat(RemainingAmount || 0);
//                 // let WorkApprovedAmountUpdate = (proposalcost - PaidAmount);

//                 setData({
//                     ...data,
//                     PaidAmount: PaidAmount || 0,
//                     // RemainingAmount: RemainingAmountUpdated,
//                     WorkName: id,
//                     // fillingForm: status,
//                     fillingForm: "first",

//                     // RemainingProposalCost: status == "first" ? (data.ProposalCost || 0) : (RemainingProjectAmount || 0),
//                     RemainingProposalCost: data.ProposalCost || 0,
//                     OriginalPaidAmount: OriginalPaidAmount || 0,
//                     OriginalRemainingAmount: OriginalRemainingAmount || 0,
//                 });

//                 setOriginalRemaining(RemainingAmountUpdated);
//             }
//         } catch (err) {
//             console.log(err);
//             alert(err);
//         }
//     };

//     const SortProposalIDByMHUID = async (id) => {
//         console.log("sortproposalidbymhuid :: ", id);
//         try {
//             if (data.HeadCode && data.ProposalYear && data.talulka) {
//                 let res1 = FetchedFData.filter(
//                     (item) => item.TechnicalSanctionNo == id
//                 );
//                 console.log("Proposal ID Get from Technical UID --- >  ", id, res1);
//                 const uniqueProposalData = res1.reduce((acc, curr) => {
//                     if (!acc.find((item) => item.ProposalID === curr.ProposalID)) {
//                         acc.push({
//                             ProposalID: curr.ProposalID,
//                             ProposalName: curr.Work_name,
//                         });
//                     }
//                     return acc;
//                 }, []);
//                 setProposalID(uniqueProposalData);
//                 setData({
//                     ...data,
//                     TechnicalSanctionUID: id,
//                     ContractorName: "",
//                     ProposalId: "",
//                     WorkName: "",
//                     WorkOrderDate: "",
//                     WorkEndDate: "",
//                     WorkOrderNo: "",
//                     ProposalCost: "0",
//                     RemainingProposalCost: "0",
//                     ApprovedWorkAmount: "0",
//                     PaidAmount: "0",
//                     CompletedProgress: "",
//                     RemainingAmount: "0",
//                     fillingForm: "second",
//                     OriginalRemainingAmount: "0",
//                     OriginalPaidAmount: "0",
//                     CopyOfWorkOrder: null,
//                 });
//                 document.getElementById("CopyOfWorkOrder").value = "";
//             }
//         } catch (err) {
//             console.log(err);
//             alert(err);
//         }
//     };

//     useEffect(() => {
//         FetchData();
//     }, []);

//     useEffect(() => {
//         setData((prev) => {
//             const approved = Number(prev.ApprovedWorkAmount || 0);
//             const paid = Number(prev.PaidAmount || 0);

//             return {
//                 ...prev,
//                 RemainingAmount: Math.max(approved - paid, 0)
//             };
//         });
//     }, [data.ApprovedWorkAmount, data.PaidAmount]);

//     const GetParticularTechnicalSanctionByProposal = async (proposalID) => {
//         let res = await GetBudgetHeadInfo(
//             proposalID,
//             "GetParticularTechnicalSanctionByProposal"
//         );
//         console.log(
//             "Data i get for GetParticularTechnicalSanctionByProposal :: ",
//             res
//         );
//         setTechnicalSanctionUid(res);
//     };

//     const processFile = (file) => {
//         return new Promise(async (resolve, reject) => {
//             try {
//                 const imageTypes = ["image/jpeg", "image/jpg", "image/png"];
//                 const pdfTypes = ["application/pdf"];

//                 // ===== IMAGE FILE =====
//                 if (imageTypes.includes(file.type)) {
//                     const exifData = await exifr.parse(file, [
//                         "GPSLatitude",
//                         "GPSLongitude",
//                     ]);
//                     if (exifData && (exifData.GPSLatitude || exifData.GPSLongitude)) {
//                         console.warn(
//                             `⚠️ EXIF GPS data found in ${file.name}. It will be stripped.`
//                         );
//                     }

//                     const reader = new FileReader();
//                     reader.onload = (e) => {
//                         const img = new Image();
//                         img.onload = () => {
//                             const canvas = document.createElement("canvas");
//                             canvas.width = img.width;
//                             canvas.height = img.height;
//                             const ctx = canvas.getContext("2d");
//                             ctx.drawImage(img, 0, 0);

//                             canvas.toBlob((blob) => {
//                                 const cleanedFile = new File([blob], file.name, {
//                                     type: file.type,
//                                 });
//                                 resolve(cleanedFile);
//                             }, file.type);
//                         };

//                         img.onerror = reject;
//                         img.src = e.target.result;
//                     };
//                     reader.onerror = reject;
//                     reader.readAsDataURL(file);
//                     return;
//                 }

//                 // ===== PDF FILE =====
//                 if (pdfTypes.includes(file.type)) {
//                     const reader = new FileReader();
//                     reader.onload = (e) => {
//                         // Read as ArrayBuffer instead of text
//                         const arrayBuffer = e.target.result;
//                         const uint8Array = new Uint8Array(arrayBuffer);

//                         // Convert to string for pattern matching
//                         const textContent = new TextDecoder("latin1").decode(uint8Array);

//                         // More precise patterns with context
//                         const dangerousPatterns = [
//                             /\/JavaScript\s*<</, // JavaScript object definition
//                             /\/JS\s*\(/, // JS action with parenthesis
//                             /\/AA\s*<</, // Additional Actions object
//                             /\/OpenAction\s*<</, // OpenAction object
//                             /\/Launch\s*<</, // Launch action object
//                             /\/RichMedia\s*<</, // RichMedia object
//                         ];

//                         const isMalicious = dangerousPatterns.some((pattern) =>
//                             pattern.test(textContent)
//                         );

//                         if (isMalicious) {
//                             alert(
//                                 `⚠️ Suspicious PDF detected in file "${file.name}". The page will reload.`
//                             );

//                             return reject(new Error("Malicious PDF detected"));
//                         }

//                         resolve(file); // safe PDF
//                     };
//                     reader.onerror = reject;
//                     reader.readAsArrayBuffer(file); // Changed from readAsText
//                     return;
//                 }

//                 // ===== OTHER FILE TYPES =====
//                 resolve(file);
//             } catch (error) {
//                 console.error("Error processing file:", error);
//                 reject(error);
//             }
//         });
//     };

//     // handle file input changes and process files immediately to validate / strip metadata
//     const handleWorkOrderFile = async (e) => {
//         const file = e.target.files && e.target.files[0];
//         const allowedTypes = [
//             "application/pdf",
//             "application/vnd.ms-excel", // .xls
//             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
//             "image/jpeg",
//             "image/png",
//         ];

//         if (!allowedTypes.includes(file.type)) {
//             alert("Only PDF, Excel, JPG, JPEG, PNG files are allowed");
//             e.target.value = ""; // Reset input
//             return;
//         }
//         if (!file) {
//             setProcessedProposalCopy(null);
//             return;
//         }
//         setFileProcessing(true);
//         try {
//             const cleaned = await processFile(file);
//             setProcessedProposalCopy(cleaned);
//         } catch (err) {
//             console.error("Error processing ProposalCopy:", err);
//             alert("Invalid Proposal Copy file. Please choose a different file.");
//             e.target.value = "";
//             setProcessedProposalCopy(null);
//         } finally {
//             setFileProcessing(false);
//         }
//     };

//     return (
//         <>
//             <div
//                 className="col-12 pb-5"
//                 style={{
//                     backgroundColor: "#EFF3F8",
//                     height: "90vh",
//                     overflowX: "hidden",
//                     overflowY: "scroll",
//                 }}
//             >
//                 <div className="col-12 m-auto my-5 budgetContainer">
//                     <div className="m-auto my-5 budgetElement">
//                         {loading && (
//                             <div
//                                 style={{
//                                     position: "fixed",
//                                     top: 0,
//                                     left: 0,
//                                     width: "100%",
//                                     height: "100%",
//                                     background: "rgba(255, 255, 255, 0.7)",
//                                     backdropFilter: "blur(4px)",
//                                     zIndex: 9999,
//                                     display: "flex",
//                                     justifyContent: "center",
//                                     alignItems: "center",
//                                 }}
//                             >
//                                 <div
//                                     style={{
//                                         border: "6px solid #f3f3f3",
//                                         borderTop: "6px solid #007bff",
//                                         borderRadius: "50%",
//                                         width: "60px",
//                                         height: "60px",
//                                         animation: "spin 1s linear infinite",
//                                     }}
//                                 />
//                                 <style>
//                                     {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//                                 </style>
//                             </div>
//                         )}

//                         <div className="row px-1 mb-4 mt-3">
//                             <div style={{ display: "flex", alignItems: "center" }}>
//                                 <img
//                                     src="/Bill-Creation-Blue64.png"
//                                     alt="TechnicalSanction"
//                                     style={{ width: "32px", height: "32px" }}
//                                     className="my-auto me-2"
//                                 />
//                                 <h3 className="text-left fw-bold mt-2">
//                                     {t("Work Order Details")}
//                                 </h3>
//                             </div>
//                             <div className="col-12 mt-4">
//                                 <p
//                                     className="py-2 ps-1 fw-bold text-danger"
//                                     style={{ backgroundColor: "#FBE7E7" }}
//                                 >
//                                     {t("Note : Fields marked with * are mandatory")}
//                                 </p>
//                             </div>
//                         </div>

//                         <form action="">
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5 my-auto ">
//                                         <label className="my-auto">
//                                             {t("Head Code")} <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <select
//                                             name="HeadCode"
//                                             value={data.HeadCode}
//                                             id=""
//                                             className="py-2"
//                                             onChange={(e) => {
//                                                 HandleChangeData(e);
//                                                 FetchDataRelatedtoZilla(e.target.value, "ProjectId");
//                                             }}
//                                             style={{
//                                                 color: data.HeadCode === "" ? "#999" : "#333",
//                                                 fontWeight: "500",
//                                                 padding: "8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "4px",
//                                                 backgroundColor: "#fff",
//                                             }}
//                                         >
//                                             <option value="" disabled>
//                                                 {t("Choose Head Code")}
//                                             </option>
//                                             {HeadCode &&
//                                                 HeadCode.map((val, index) => {
//                                                     return (
//                                                         <option key={index} value={val.HeadID}>
//                                                             {val.HeadName}
//                                                         </option>
//                                                     );
//                                                 })}
//                                         </select>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5  ">
//                                         <label>
//                                             {t("Approved Year")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <select
//                                             name="ProposalYear"
//                                             value={data.ProposalYear}
//                                             id=""
//                                             className="py-2"
//                                             onChange={(e) => {
//                                                 HandleChangeData(e);
//                                                 sortDatabyProposalYear(e.target.value);
//                                             }}
//                                             style={{
//                                                 color: data.ProposalYear === "" ? "#999" : "#333",
//                                                 fontWeight: "500",
//                                                 padding: "8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "4px",
//                                                 backgroundColor: "#fff",
//                                             }}
//                                         >
//                                             <option value="" disabled>
//                                                 {t("Choose Approved Year")}
//                                             </option>
//                                             <option value="2024-2025">2024 - 2025</option>
//                                             <option value="2025-2026">2025 - 2026</option>
//                                         </select>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5">
//                                         <label>
//                                             {t("Zilla Parishad")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <select
//                                             name="talulka"
//                                             value={data.talulka}
//                                             className="py-2"
//                                             onChange={(e) => {
//                                                 HandleChangeData(e);
//                                                 sortDataByZilla(e.target.value);
//                                             }}
//                                             style={{
//                                                 color: data.talulka === "" ? "#999" : "#333",
//                                                 fontWeight: "500",
//                                                 padding: "8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "4px",
//                                                 backgroundColor: "#fff",
//                                             }}
//                                         >
//                                             <option value="" disabled>
//                                                 {t("Select Zilla Parishad")}
//                                             </option>
//                                             {taluka &&
//                                                 taluka.map((val, index) => {
//                                                     return (
//                                                         <option value={val} key={index}>
//                                                             {val}
//                                                         </option>
//                                                     );
//                                                 })}
//                                         </select>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5">
//                                         <label>
//                                             {t("MHUID Number")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <select
//                                             name="TechnicalSanctionUID"
//                                             value={data.TechnicalSanctionUID}
//                                             className="py-2"
//                                             onChange={(e) => {
//                                                 HandleChangeData(e);
//                                                 SortProposalIDByMHUID(e.target.value);
//                                             }}
//                                             style={{
//                                                 color: data.ProposalId === "" ? "#999" : "#333",
//                                                 fontWeight: "500",
//                                                 padding: "8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "4px",
//                                                 backgroundColor: "#fff",
//                                             }}
//                                         >
//                                             <option value="" disabled>
//                                                 {t("Select MHUID Number")}
//                                             </option>
//                                             {TechnicalSanctionUid &&
//                                                 TechnicalSanctionUid.length > 0 &&
//                                                 TechnicalSanctionUid.map((val, index) => {
//                                                     return (
//                                                         <option value={val.TechnicalSanctionNo} key={index}>
//                                                             {val.TechnicalSanctionNo}
//                                                         </option>
//                                                     );
//                                                 })}
//                                         </select>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5">
//                                         <label>
//                                             {t("Work Name")} <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <select
//                                             name="ProposalId"
//                                             value={data.ProposalId}
//                                             className="py-2"
//                                             onChange={(e) => {
//                                                 HandleChangeData(e);
//                                             }}
//                                             style={{
//                                                 color: data.ProposalId === "" ? "#999" : "#333",
//                                                 fontWeight: "500",
//                                                 padding: "8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "4px",
//                                                 backgroundColor: "#fff",
//                                             }}
//                                         >
//                                             <option value="" disabled>
//                                                 {t("Select Work Name")}
//                                             </option>
//                                             {ProposalID &&
//                                                 ProposalID.map((val, index) => {
//                                                     return (
//                                                         <option value={val.ProposalName} key={index}>
//                                                             {val.ProposalName}
//                                                         </option>
//                                                     );
//                                                 })}
//                                         </select>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5"></div>
//                                     <div className="col-7">
//                                         <button
//                                             type="button"
//                                             className="btn btn-success px-4 py-1"
//                                             onClick={handleAddProposal}
//                                             style={{
//                                                 display: "flex",
//                                                 justifyContent: "center",
//                                                 alignItems: "center",
//                                                 gap: "5px",
//                                             }}
//                                         >
//                                             <img
//                                                 src="/Added-Work-Names64.png"
//                                                 alt="Add"
//                                                 style={{ width: "14px", height: "14px" }}
//                                             />
//                                             {t("Add Works")}
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* 🧮 NEW TABLE SECTION */}
//                             {selectedProposals.length > 0 && (
//                                 <div className="col-12 mt-4">
//                                     <h5 className="fw-bold mb-2">{t("Added Works")}</h5>
//                                     <div
//                                         className="col-12 tableDesign"
//                                         style={{
//                                             background: "#0098d5",
//                                             borderRadius: "10px 10px 0 0",
//                                         }}
//                                     >
//                                         <table
//                                             className="m-0 p-0"
//                                             style={{
//                                                 width: "100%",
//                                                 borderCollapse: "collapse",
//                                             }}
//                                         >
//                                             <thead>
//                                                 <tr
//                                                     style={{
//                                                         color: "white",
//                                                         height: "3rem",
//                                                         fontSize: "13px",
//                                                     }}
//                                                 >
//                                                     <th>Sr.No.</th>
//                                                     <th>{t("Work Name")}</th>
//                                                     <th>{t("Work Cost")}</th>
//                                                     {/* <th>{t("Remaining Proposal Work Cost")}</th> */}
//                                                     <th>{t("MHUID Number")}</th>
//                                                     <th>{t("Action")}</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {selectedProposals.map((p, i) => {
//                                                     const bgColor = i % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                     return (
//                                                         <tr key={i} style={{ backgroundColor: bgColor }}>
//                                                             <td>{i + 1}</td>
//                                                             <td>{p.ProposalName}</td>
//                                                             <td>{p.ProposalCost}</td>
//                                                             {/* <td>{p.RemainingProposalCost}</td> */}
//                                                             <td>{p.TechnicalSanctionUID}</td>
//                                                             <td>
//                                                                 <button
//                                                                     className="btn btn-danger btn-sm mx-auto"
//                                                                     onClick={() => handleRemoveProposal(i)}
//                                                                     style={{
//                                                                         display: "flex",
//                                                                         justifyContent: "center",
//                                                                         alignItems: "center",
//                                                                         gap: "5px",
//                                                                     }}
//                                                                 >
//                                                                     <img
//                                                                         src="/Remove-64.png"
//                                                                         alt="Remove"
//                                                                         style={{ width: "14px", height: "14px" }}
//                                                                     />
//                                                                     {t("Remove")}
//                                                                 </button>
//                                                             </td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             )}
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5 my-auto ">
//                                         <label className="my-auto">
//                                             {t("Vendor Name")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <select
//                                             name="ContractorName"
//                                             value={data.ContractorName}
//                                             className="form-select py-2"
//                                             onChange={HandleChangeData}
//                                             style={{
//                                                 color: data.Bidder_CompanyName === "" ? "#999" : "#333",
//                                                 fontWeight: "500",
//                                                 padding: "8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "4px",
//                                                 backgroundColor: "#fff",
//                                             }}
//                                         >
//                                             <option value="">{t("Choose Vendor")}</option>
//                                             {Contractor &&
//                                                 Contractor.map((val, index) => {
//                                                     return (
//                                                         <option key={index} value={val.Bidder_CompanyName}>
//                                                             {val.Bidder_CompanyName}
//                                                         </option>
//                                                     );
//                                                 })}
//                                         </select>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5 my-auto ">
//                                         <label className="my-auto">
//                                             {t("Work Order Name")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="text"
//                                             placeholder={t("Enter Work Order Name")}
//                                             className="form-control py-2"
//                                             name="WorkName"
//                                             value={data.WorkName}
//                                             onChange={(e) => {
//                                                 let value = e.target.value
//                                                     .replace(/[^a-zA-Z0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g, "")
//                                                     .replace(/^\s+/, "");
//                                                 HandleChangeData({
//                                                     target: { name: "WorkName", value },
//                                                 });
//                                                 SortAMountsByWorkName(e.target.value);
//                                             }}

//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5 my-auto ">
//                                         <label className="my-auto">
//                                             {t("Work Order Number")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="text"
//                                             placeholder={t("Enter Work Order Number")}
//                                             className="form-control py-2"
//                                             name="WorkOrderNo"
//                                             value={data.WorkOrderNo}
//                                             onChange={(e) => {
//                                                 let value = e.target.value
//                                                     .replace(/[^a-zA-Z0-9\s]/g, "")
//                                                     .replace(/^\s+/, "");
//                                                 HandleChangeData({
//                                                     target: { name: "WorkOrderNo", value },
//                                                 });
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5  ">
//                                         <label>
//                                             {t("Work Order Start Date")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="datetime-local"
//                                             placeholder={t("Enter Work Order Date")}
//                                             className="form-control py-2"
//                                             value={data.WorkOrderDate}
//                                             name="WorkOrderDate"
//                                             onChange={HandleChangeData}
//                                             onKeyDown={(e) => e.preventDefault()}
//                                             required
//                                             max={new Date().toISOString().slice(0, 16)}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5  ">
//                                         <label>
//                                             {t("Work Order End Date")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="datetime-local"
//                                             placeholder={t("Enter Work Order End Date")}
//                                             className="form-control py-2"
//                                             value={data.WorkEndDate}
//                                             name="WorkEndDate"
//                                             onChange={HandleChangeData}
//                                             onKeyDown={(e) => e.preventDefault()}
//                                             required
//                                             min={data.WorkOrderDate}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5  ">
//                                         <label>
//                                             {t("Total Work Cost")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="text"
//                                             placeholder={t("Enter Work End Date")}
//                                             className="form-control py-2"
//                                             value={TotalSelectedProposalCost}
//                                             disabled
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5 my-auto ">
//                                         <label className="my-auto">
//                                             {t("Approved Work Order Amount")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="number"
//                                             placeholder={t("Enter Approved Work Order Amount")}
//                                             className="form-control py-2"
//                                             name="ApprovedWorkAmount"
//                                             value={data.ApprovedWorkAmount}
//                                             onChange={HandleChangeData}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5 my-auto ">
//                                         <label className="my-auto">
//                                             {t("Completed Progress")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <select
//                                             value={data.CompletedProgress}
//                                             // onChange={(e) => {
//                                             //   setData((prev) => ({
//                                             //     ...prev,
//                                             //     CompletedProgress: e.target.value,
//                                             //   }));
//                                             // }}
//                                             style={{
//                                                 color: data.CompletedProgress === "" ? "#999" : "#333",
//                                                 fontWeight: "500",
//                                                 padding: "8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "4px",
//                                                 backgroundColor: "#fff",
//                                             }}
//                                             disabled
//                                         >
//                                             {/* <option value="" disabled>{t("Completed Progress")}</option> */}
//                                             <option value="NA">NA</option>
//                                             <option value="30">30%</option>
//                                             <option value="50">50%</option>
//                                             <option value="100">100%</option>
//                                         </select>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5 my-auto ">
//                                         <label className="my-auto">{t("Paid Amount")}</label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="number"
//                                             placeholder={t("Enter Paid Amount")}
//                                             className="form-control py-2"
//                                             name="PaidAmount"
//                                             value={data.PaidAmount}
//                                             // onChange={HandleChangeData}
//                                             onChange={(e) => {
//                                                 let value = e.target.value
//                                                     .replace(/[^0-9\s]/g, "")
//                                                     .replace(/^\s+/, "");
//                                                 HandleChangeData({
//                                                     target: { name: "PaidAmount", value },
//                                                 });
//                                             }}

//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5 my-auto ">
//                                         <label className="my-auto">
//                                             {t("Remaining Amount")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="text"
//                                             placeholder={t("Enter Remaining Amount")}
//                                             className="form-control py-2"
//                                             name='RemainingAmount'
//                                             value={data.RemainingAmount}
//                                             onChange={HandleChangeData}
//                                             disabled
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 elements">
//                                 <div className="row">
//                                     <div className="col-5  ">
//                                         <label>
//                                             {t("Copy of Work Order")}{" "}
//                                             <span style={{ color: "red" }}>*</span>
//                                         </label>
//                                     </div>
//                                     <div className="col-7">
//                                         <input
//                                             type="file"
//                                             className="form-control py-2"
//                                             accept=".pdf,.jpg,.jpeg,.png"
//                                             id="CopyOfWorkOrder"
//                                             //  ref={CopyOfWorkOrder}
//                                             onChange={handleWorkOrderFile}
//                                         />
//                                         {processedProposalCopy && (
//                                             <div style={{ fontSize: 12, marginTop: 6 }}>
//                                                 {t("Selected")}: {processedProposalCopy.name}
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 ms-auto my-4">
//                                 <div className="row">
//                                     <div className="col-5"></div>
//                                     <div className="col-7">
//                                         <div className="col-12">
//                                             <button
//                                                 type="button"
//                                                 disabled={loading || fileProcessing || isSubmittingRef.current}
//                                                 className="px-4 py-1 btn btn-primary"
//                                                 onClick={handleSubmit}
//                                                 style={{
//                                                     cursor: loading ? "not-allowed" : "pointer",
//                                                     opacity: loading ? 0.7 : 1
//                                                 }}
//                                             >
//                                                 {loading ? "Saving..." : t("Save")}
//                                             </button>
//                                             <button className="px-4 py-1 btn btn-danger mx-4">
//                                                 {t("Cancel")}
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };
// export default CreateWorkOrder;

import React, { useContext, useEffect, useRef, useState } from "react";
import "./workorder.css";
import Application from "../../../StateContext/Application.js";
import { apiurl } from "../../../../../path.js";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
import * as exifr from "exifr";
import Select from "react-select";
import validateFile from "../../../../../utils/fileUploadHelper.js"
import { jwtDecode } from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CreateWorkOrder = () => {
    // Department access ID -> head codes allowed for that department
const DEPARTMENT_HEADCODES = {
  1: ["3054","2515"], // बांधकाम विभाग
  2: ["2515"], // पाणी पुरवठा
};

const matchesUserCode = (headId, code) =>
  headId === code ||
  headId.startsWith(code + "-") ||
  headId.startsWith(code + "(") ||
  headId.startsWith(code + " ");

  const getWorkOrderType = () => {
  try {
    const token = localStorage.getItem("Token");
    if (!token) return "";

    const decoded = jwtDecode(token);
    let departmentIds = decoded?.DepartmentAccessID;

    if (typeof departmentIds === "string") {
      try {
        departmentIds = JSON.parse(departmentIds);
      } catch {
        departmentIds = [departmentIds];
      }
    }

    if (!Array.isArray(departmentIds)) {
      departmentIds =
        departmentIds == null ? [] : [departmentIds];
    }

    return departmentIds.map(Number).includes(2)
      ? "New Work Order"
      : "";
  } catch (error) {
    console.error("Error reading DepartmentAccessID:", error);
    return "";
  }
};


  const isSubmittingRef = useRef(false);
  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);
  const { GetProjectInfo, GetBudgetHeadInfo, WorkOrderCreation, TypesOfWork, Usermenu, GetMyDepartmentAccess,CheckWorkNameDuplicate } =
    operation;
  const [projectId, setProjectId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [HeadId, setHeadID] = useState([]);
  const [relatedHeadID, setRelatedHeadID] = useState([]);
  const [Contractor, setContractor] = useState([]);
  const [HeadCode, setHeadCode] = useState([]);
  const [FetchedFData, setFetchedFData] = useState([]);
  const [taluka, setTaluka] = useState([]);
  const [ulb, setUlb] = useState([]);
  const [GrnData, setGrnData] = useState([]);
  const [ProposalID, setProposalID] = useState([]);
  const [proposalcost, setProposalCost] = useState("0");
  const [OriginalRemaining, setOriginalRemaining] = useState("0");
  const [ProposalRemaingAmount, setProposalRemainigAmount] = useState("0");
  const [TechnicalSanctionUid, setTechnicalSanctionUid] = useState([]);
  const [selectedProposals, setSelectedProposals] = useState([]);
  const [panError, setPanError] = useState("");
  const [TotalSelectedProposalCost, setTotalSelectedProposalCost] = useState(0);
  const [usedMHUIDs, setUsedMHUIDs] = useState([]);
  const [processedProposalCopy, setProcessedProposalCopy] = useState(null);
  const [fileProcessing, setFileProcessing] = useState(false);
    const workOrderDateRef = useRef(null);

  // const [userDeptIds, setUserDeptIds] = useState([]);
  
  // useEffect(() => {
  //   (async () => {
  //     const data = await Usermenu();   // add Usermenu to your context destructuring
  //     const raw = data?.Data?.DepartmentAccessID;
  //     try {
  //       const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
  //       setUserDeptIds((Array.isArray(parsed) ? parsed : [parsed]).map(Number).filter(Boolean));
  //     } catch { setUserDeptIds([]); }
  //   })();
  // }, []);
  
  // const toIds = (v) => {
  //   try {
  //     const p = typeof v === "string" ? JSON.parse(v) : v;
  //     return (Array.isArray(p) ? p : [p]).map(Number).filter(Boolean);
  //   } catch { return []; }
  // };
  
  // const visibleContractors = (Contractor || []).filter((v) => {
  //   if (userDeptIds.length === 0) return true;          // no department info -> don't hide
  //   return toIds(v.DepartmentAccessID).some((id) => userDeptIds.includes(id));
  // });

  useEffect(() => {
    const preventWheel = (e) => {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    };
    window.addEventListener("wheel", preventWheel, { passive: true });
    return () => window.removeEventListener("wheel", preventWheel);
  }, []);

    //Added new state variable to store the login district
    const [loginDistrict, setLoginDistrict] = useState("");
    useEffect(() => {
      const token = localStorage.getItem("Token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          setLoginDistrict(decoded?.District);
        } catch (error) {
          console.error("Invalid token:", error);
        }
      }
    }, []);

  const [WorkId, setWorkId] = useState([]);
  const [getWork, setWork] = useState([]);

  const [error, setError] = useState("");
  const [data, setData] = useState({
    HeadCode: "",
    DepartmentAccessID: "",          // NEW
    ProposalYear: "",
    CurrentYear: "",
    talulka: "",
    ulb: "",
    GrID: "",
    ProposalId: "",
    PanNo: "NA",
    ContractorName: "",
    ContractorUniqueID: "",
    workClass: "",
    workType: "",
    WorkName: " ",
    WorkOrderNo: null,
    WorkOrderDate: null,
    WorkEndDate: null,
    ProposalCost: "0",
    RemainingProposalCost: "0",
    ApprovedWorkAmount: "0",
    PaidAmount: "0",
    CompletedProgress: "",
    RemainingAmount: "0",
    fillingForm: "second",
    OriginalRemainingAmount: "0",
    OriginalPaidAmount: "0",
    TechnicalSanctionUID: "",
    JOB_ID: "",
    // NEW FIELDS
    // WorkOrderType: "",
    WorkOrderType: getWorkOrderType(),
    workApprovedGRDate: null,
  });

  console.log("selected ulb", data.ulb);
///////////Addded only display for common department
const [myDepartments, setMyDepartments] = useState([]);
const [departmentsLoaded, setDepartmentsLoaded] = useState(false);
useEffect(() => {
  (async () => {
    try {
      const r = await GetMyDepartmentAccess();
      const list = r?.data?.departments || [];
      setMyDepartments(list);
      if (list.length === 1) {   // only one -> automatic
        setData((prev) => ({ ...prev, DepartmentAccessID: list[0].id }));
      }
    } catch (e) {
      console.error("GetMyDepartmentAccess failed", e);
    } finally {
      setDepartmentsLoaded(true);
    }
  })();
}, []);
// Department 2 (पाणी पुरवठा) -> New Work Order, otherwise let the user choose
useEffect(() => {
  if (!data.DepartmentAccessID) return;
  setData((prev) => {
    if (String(prev.DepartmentAccessID) === "2") {
      return { ...prev, WorkOrderType: "New Work Order" };
    }
    // विभाग 2 सोडल्यावर, फक्त जबरदस्तीने ठरलेला type पुसा
    return prev.WorkOrderType === "New Work Order"
      ? { ...prev, WorkOrderType: "" }
      : prev;
  });
}, [data.DepartmentAccessID]);
// head codes visible = user's own head codes ∩ selected department's head codes
const allowedHeadPrefixes = data.DepartmentAccessID
  ? DEPARTMENT_HEADCODES[Number(data.DepartmentAccessID)] || []
  : null;
const visibleHeadCodes = !departmentsLoaded
  ? []
  : myDepartments.length === 0
    ? HeadCode                       // no department info -> user's own head codes
    : !allowedHeadPrefixes
      ? []                           // several departments, none chosen yet
      : HeadCode.filter((h) =>
          allowedHeadPrefixes.some((c) =>
            matchesUserCode(String(h.HeadID || "").trim(), c),
          ),
        );
// one effect covers: dropdown change, automatic single department
useEffect(() => {
  if (!departmentsLoaded) return;
  // selected head code not allowed any more -> clear it
  if (data.HeadCode && !visibleHeadCodes.some((h) => h.HeadID === data.HeadCode)) {
    HandleChangeData({ target: { name: "HeadCode", value: "" } });
    return;
  }
  // exactly one head code left -> select it
  if (visibleHeadCodes.length === 1 && data.HeadCode !== visibleHeadCodes[0].HeadID) {
    HandleChangeData({ target: { name: "HeadCode", value: visibleHeadCodes[0].HeadID } });
    FetchDataRelatedtoZilla(visibleHeadCodes[0].HeadID);
  }
}, [departmentsLoaded, data.DepartmentAccessID, HeadCode, data.HeadCode]);
// vendors of the selected department only
const toIds = (v) => {
  try {
    const p = typeof v === "string" ? JSON.parse(v) : v;
    return (Array.isArray(p) ? p : [p]).map(Number).filter(Boolean);
  } catch { return []; }
};
const visibleContractors = !departmentsLoaded
  ? []
  : (Contractor || []).filter((v) => {
      if (myDepartments.length === 0) return true;          // no department info -> don't hide
      if (!data.DepartmentAccessID) return false;           // several departments, none chosen
      return toIds(v.DepartmentAccessID).includes(Number(data.DepartmentAccessID));
    });
    // ////////////////////////////////
  const GetTypesOfWork = async () => {
    try {
      let res = await TypesOfWork(data.HeadCode);
      setWorkId(res);

      if (
        data.HeadCode ===
        "3054-2419(Roads and bridge repair maintenance program)"
      ) {
        let workNames = res.filter((item) => item.Work_Type === data.workClass);
        setWork(workNames);
      } else {
        setWork(res);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data.HeadCode) {
      GetTypesOfWork();
    }
  }, [data.HeadCode, data.workClass]);

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    if (value.length === 1 && value[0] === " ") return;

    // Prevent negative numbers for numeric inputs (existing behaviour)
    if (
      name === "ApprovedWorkAmount" ||
      name === "PaidAmount" ||
      name === "ProposalCost"
    ) {
      const number = parseFloat(value);
      if (!isNaN(number) && number < 0) return;
    }

    // --- ADDED VALIDATION START ---
    if (name === "PaidAmount") {
      const approvedAmount = Number(data.ApprovedWorkAmount) || 0;
      const enteredAmount = Number(value) || 0;

      if (enteredAmount > approvedAmount) {
        // Option 1: Just return to prevent typing (silent)
        // Option 2: Alert the user
        // alert(t("Paid Amount cannot be greater than Approved Work Amount"));
        return;
      }
    }
    if (name === "ApprovedWorkAmount") {
      const proposalCost = Number(data.ProposalCost) || 0;
      const enteredAmount = Number(value) || 0;

      if (enteredAmount > proposalCost) {
        return;
      }
    }

    if (name === "WorkOrderDate") {
      setData((prev) => ({
        ...prev,
        workApprovedGRDate: "",
      }));
    }

    // Define the hierarchy/order of fields in the form.
    const order = [
      "HeadCode",
      "ProposalYear",
      "CurrentYear",
      "talulka",
      "TechnicalSanctionUID",
      "ProposalId",
      "ContractorName",
      "WorkName",
      "WorkOrderNo",
      "WorkOrderDate",
      "WorkEndDate",
      "workApprovedGRDate",
      "TotalSelectedProposalCost",
      "ApprovedWorkAmount",
      "CompletedProgress",
      "PaidAmount",
      "RemainingAmount",
      "CopyOfWorkOrder",
    ];

    // Helper to reset fields that come *after* the changed field in the order
    const resetBelow = (field) => {
      const idx = order.indexOf(field);
      if (idx === -1) return;

      // Build partial update for `data`
      const resetData = { ...data };
      // setData(resetData);
      // For each field after the changed one, reset sensible defaults
      for (let i = idx + 1; i < order.length; i++) {
        const f = order[i];
        switch (f) {
          case "ProposalYear":
          case "HeadCode":
          case "talulka":
          case "TechnicalSanctionUID":
          case "ProposalId":
          case "WorkName":
          case "WorkOrderNo":
            resetData[f] = "";
            break;
          case "CompletedProgress":
            resetData[f] = "NA";
            break;

            // NEW: keep the vendor pair in sync when anything upstream resets it
    case "ContractorName":
      resetData.ContractorName = "";
      resetData.ContractorUniqueID = "";
      break;

          // FIX: Instead of resetting to "", set it to the current total from the table
          case "ApprovedWorkAmount":
            if (data.WorkOrderType === "Existing Work Order") {
              resetData[f] = data.ProposalCost || 0;
            } else {
              resetData[f] = TotalSelectedProposalCost || 0;
            }
            break;
          case "RemainingAmount":
            resetData[f] = Math.max(
              TotalSelectedProposalCost - (Number(resetData.PaidAmount) || 0),
              0,
            );
            break;
          case "CopyOfWorkOrder":
            break;
          default:
            resetData[f] = "";
        }
      }

      // Apply targeted resets to other pieces of component state that depend on earlier fields
      // If any of the fields before/including ProposalId were changed, the list of proposals, taluka,
      // technical sanctions and selectedProposals should be cleared (so old options don't leak).
      const clearProposalRelated = [
        "HeadCode",
        "ProposalYear",
        "talulka",
        "TechnicalSanctionUID",
        "ProposalId",
      ].some((f) => f === field || order.indexOf(f) < order.indexOf(field));

      // But we want to clear selected proposals when any of the FIRST five fields change
      if (
        [
          "HeadCode",
          "ProposalYear",
          "talulka",
          "TechnicalSanctionUID",
          "ProposalId",
        ].includes(field)
      ) {
        setSelectedProposals([]);
        setTotalSelectedProposalCost(0);
      }

      // If head or year changed, also clear taluka/proposals lists and technical uid list
      if (field === "HeadCode") {
        setTaluka([]);
        setFetchedFData([]);
        setProposalID([]);
        setTechnicalSanctionUid([]);
      }
      if (field === "ProposalYear") {
        setProposalID([]);
        setTechnicalSanctionUid([]);
      }
      if (field === "talulka") {
        setTechnicalSanctionUid([]);
        setProposalID([]);
      }
      if (field === "TechnicalSanctionUID") {
        setProposalID([]);
        // setData(data.ContractorName)
      }
      if (field === "ProposalId") {
        // Proposal changed — clear previously added works (they belong to previous proposal)
        setSelectedProposals([]);
        // setTotalSelectedProposalCost(0);
      }

      // Clear processed file if user changed anything above CopyOfWorkOrder
      if (
        [
          "HeadCode",
          "ProposalYear",
          "talulka",
          "TechnicalSanctionUID",
          "ProposalId",
          "WorkName",
          "WorkOrderNo",
        ].includes(field)
      ) {
        setProcessedProposalCopy(null);
      }
// फक्त खरोखर बदललेले fields लागू करा, म्हणजे WorkOrderType / DepartmentAccessID कधीही पुसले जाणार नाहीत
const patch = {};
Object.keys(resetData).forEach((k) => {
  if (resetData[k] !== data[k]) patch[k] = resetData[k];
});
setData((prev) => ({ ...prev, ...patch }));

      // Finally set data state with resets already applied (we will override the changed field below)
      // setData(resetData);
    };

    // Execute resets for fields that need to clear downstream values
    resetBelow(name);

    // Now set the changed field value (after resets)
    // Use functional update to avoid stale state race
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
const hasDuplicateWorkName = async (workName, validationContext) => {
    const trimmedName = workName?.trim();
    if (!trimmedName) {
      alert("Work Name is required.");
      return true;
    }
 
    try {
      const result = await CheckWorkNameDuplicate(
        trimmedName,
        validationContext,
      );
      if (result?.isDuplicate) alert(result.message);
      return Boolean(result?.isDuplicate);
    } catch (err) {
      alert(err?.message || "Unable to validate Work Name");
      return true;
    }
  };
  // paste this in CreateWorkOrder.js replacing the current handleSubmit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🚫 HARD BLOCK (instant, no re-render needed)
    if (isSubmittingRef.current) return;

    // ---------------- VALIDATIONS ----------------
    const requiredFields = [
      { name: "HeadCode", label: "Head Code" },
      { name: "ProposalYear", label: "Approved Year" },
      { name: "ulb", label: "Taluka" },              // NEW
      { name: "workClass", label: "Class Of Work" },  // NEW
      { name: "ProposalId", label: "Work Name" },     // NEW
      // { name: "CurrentYear", label: "Current Year" },
      // { name: "talulka", label: "Zilla Parishad" },
      // { name: "TechnicalSanctionUID", label: "Technical Sanction Number" },
      { name: "WorkOrderDate", label: "Work Order Date" },
      { name: "WorkEndDate", label: "Work End Date" },
      { name: "WorkOrderNo", label: "Work Order No" },
      { name: "ContractorUniqueID", label: "Vendor Name" },
      { name: "ApprovedWorkAmount", label: "Approved Work Amount" },
      // { name: "WorkName", label: "Work order Name" },
    ];

    // Required only for Existing Work Order
    if (data.WorkOrderType === "Existing Work Order") {
      requiredFields.push({
        name: "workApprovedGRDate",
        label: "Administrative Approved GR Date",
      });
    }

    for (const field of requiredFields) {
      const val = data?.[field.name];
      if (!val || String(val).trim() === "") {
        alert(`${field.label} is required!`);
        return;
      }
    }
const woMin = "2000-01-01";
const woMax = getWorkOrderMaxDate(data.ProposalYear);

if (
  !data.WorkOrderDate ||
  data.WorkOrderDate < woMin ||
  data.WorkOrderDate > woMax
) {
  alert(
    `Work Order Date must be between ${woMin} and ${woMax}.`
  );
  return;
}

    if (
      data.WorkOrderType === "New Work Order" &&
      (!selectedProposals || selectedProposals.length === 0)
    ) {
      alert("Please add at least one proposal before submitting!");
      return;
    }
 if (
      data.WorkOrderType === "Existing Work Order" &&
      (await hasDuplicateWorkName(data.ProposalId, data.WorkOrderType))
    ) return;

    const CopyOfWorkOrderFiles =
      document.getElementById("CopyOfWorkOrder")?.files;

    if (
      !processedProposalCopy &&
      (!CopyOfWorkOrderFiles || CopyOfWorkOrderFiles.length === 0)
    ) {
      alert("Insert Copy of Work Order (required).");
      return;
    }

    const approvedAmount = Number(data.ApprovedWorkAmount);
    if (!approvedAmount || approvedAmount <= 0) {
      alert("Approved Work Amount must be greater than 0.");
      return;
    }

    if (data.PaidAmount && Number(data.PaidAmount) > approvedAmount) {
      alert("Paid Amount can't be more than Approved Work Amount.");
      return;
    }

    // 🔒 LOCK IMMEDIATELY
    isSubmittingRef.current = true;
    setLoading(true);

    try {
      if (error) {
        alert(error);
        return; // 🚫 stop submission
      }
      const formData = new FormData();

      let OriginalRemainingProposalCost = Number(
        data.RemainingProposalCost || 0,
      );
      let remainingProposalCost =
        OriginalRemainingProposalCost - approvedAmount;

      // const approved = Number(data.ApprovedWorkAmount || 0);
      // const paid = Number(data.PaidAmount || 0);
      const approved = parseFloat(data.ApprovedWorkAmount || 0);
      const paid = parseFloat(data.PaidAmount || 0);

      const remaining = parseFloat((approved - paid).toFixed(2));

      const updatedData = {
        ...data,
        RemainingAmount: remaining,
        // ProposalCost: proposalcost,
        ProposalCost:
          data.WorkOrderType === "Existing Work Order"
            ? Number(data.ProposalCost || 0)
            : Number(TotalSelectedProposalCost || 0),
        RemainingProposalCost:
          data.fillingForm === "first"
            ? remainingProposalCost.toFixed(2)
            : OriginalRemainingProposalCost.toFixed(2),
      };

      let finalProposalCopy;
      try {
        finalProposalCopy = processedProposalCopy
          ? processedProposalCopy
          : await processFile(CopyOfWorkOrderFiles[0]);
      } catch {
        alert("File processing failed");
        return;
      }

      for (const key in updatedData) {
        formData.append(key, updatedData[key]);
      }

      formData.append("SelectedProposals", JSON.stringify(selectedProposals));
      formData.append("CopyOfWorkOrder", finalProposalCopy);

      const result = await WorkOrderCreation(formData);
if (result?.status === false || result?.error) {
        alert(result?.message || result?.error || "Work Order was not created");
        return;
      }
      alert(result?.message || "Work Order Created Successfully");

      // 🚀 HARD REDIRECT (no second submit possible)
      window.location.replace(window.location.href);
    } catch (error) {
      console.error(error);
      alert("Submission failed. Please try again.");
    } finally {
      setLoading(false);
      isSubmittingRef.current = false; // safety
    }
  };

  const FetchData = async () => {
    setLoading(true);
  
    try {
      let res = await GetProjectInfo("null", "all");
      let res2 = await GetProjectInfo("null", "Contractor");
      let res1 = await GetBudgetHeadInfo("null", "all");
      let res3 = await GetBudgetHeadInfo("null", "AllHeadCode");
  
      setProjectId(res);
      setHeadID(res1);
      setContractor(res2);
  
      // ============================================
      // HEAD CODE FILTERING — decode token directly,
      // don't rely on `userData` state (avoids race condition)
      // ============================================
      // let userHeadCodes = [];
      // try {
      //   const token = localStorage.getItem("Token");
      //   if (token) {
      //     const decoded = jwtDecode(token);
      //     let raw = decoded?.HeadCode;
      //     if (typeof raw === "string") {
      //       raw = JSON.parse(raw);
      //     }
      //     if (Array.isArray(raw)) {
      //       userHeadCodes = raw
      //         .filter((c) => c !== null && c !== undefined && String(c).trim() !== "")
      //         .map((c) => String(c).trim());
      //     }
      //   }
      // } catch (err) {
      //   console.error("Error decoding token for HeadCode filter:", err);
      //   userHeadCodes = [];
      // }
  
      // console.log("User HeadCodes:", userHeadCodes);
  
      // if (userHeadCodes.length === 0) {
      //   console.log("No HeadCode restriction -> Showing ALL HeadCodes");
      //   setHeadCode(res3 || []);
      //   return;
      // }
  
      // const filteredHeadCodes = (res3 || []).filter((h) => {
      //   const headId = String(h.HeadID || "").trim();
      //   return userHeadCodes.some((userCode) => headId.startsWith(userCode));
      // });
  
      // console.log("Filtered HeadCodes:", filteredHeadCodes);
      // setHeadCode(filteredHeadCodes);
  
      // if (filteredHeadCodes.length === 1) {
      //   const selectedHeadCode = filteredHeadCodes[0].HeadID;
      //   setData((prev) => ({ ...prev, HeadCode: selectedHeadCode }));
      //   FetchDataRelatedtoZilla(selectedHeadCode);
      // }

      let allowedCodes = [];
            try {
              const token = localStorage.getItem("Token");
              if (token) {
                const decoded = jwtDecode(token);
      
                const parse = (v) => {
                  if (typeof v === "string") {
                    try { v = JSON.parse(v); } catch { v = [v]; }
                  }
                  return Array.isArray(v) ? v : [];
                };
      
                const userCodes = parse(decoded?.HeadCode).map((c) => String(c).trim());
                const deptIds = parse(decoded?.DepartmentAccessID).map(Number);
      
                // Head codes permitted by the user's department(s)
                const deptCodes = deptIds.flatMap((id) => DEPARTMENT_HEADCODES[id] || []);
      
                // Must be in BOTH the user's HeadCode list AND their department's codes
                allowedCodes = userCodes.filter((c) => deptCodes.includes(c));
              }
            } catch (err) {
              console.error("Error decoding token:", err);
            }
      
            // Fail-closed
            if (allowedCodes.length === 0) {
              setHeadCode([]);
              return;
            }
      
            const filteredHeadCodes = (res3 || []).filter((h) => {
              const headId = String(h.HeadID || "").trim();
              return allowedCodes.some((code) => matchesUserCode(headId, code));
            });
      
            setHeadCode(filteredHeadCodes);
      
            if (filteredHeadCodes.length === 1) {
              const selectedHeadCode = filteredHeadCodes[0].HeadID;
              setData((prev) => ({ ...prev, HeadCode: selectedHeadCode }));
              FetchDataRelatedtoZilla(selectedHeadCode);
            }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  //--> old code
  // const FetchData = async () => {
  //   setLoading(true);
  //   try {
  //     let res = await GetProjectInfo("null", "all");
  //     let res2 = await GetProjectInfo("null", "Contractor");
  //     let res1 = await GetBudgetHeadInfo("null", "all");
  //     let res3 = await GetBudgetHeadInfo("null", "AllHeadCode");
  //     console.log("res3", res3);
  //     console.log("res2", res2);
  //     console.log("re1", res1);

  //     setProjectId(res);
  //     setHeadID(res1);
  //     setContractor(res2);
  //     setHeadCode(res3);
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const FetchDataRelatedtoZilla = async (id) => {
    try {
      let res = await GetBudgetHeadInfo(
        id,
        "GetSpecificTalukaDatabasedonHeadcode",
      );
      console.log("resss", res);

      // Ensure it's an array
      const dataArray = Array.isArray(res) ? res : [];
      setFetchedFData(dataArray);

      const uniqueTalukas = [
        ...new Set(dataArray.map((item) => item.ZillaParishad)),
      ];
      setTaluka(uniqueTalukas);
    } catch (err) {
      console.log(err);
      setFetchedFData([]);
    }
  };

  const sortDatabyProposalYear = (year) => {
    if (data.HeadCode) {
      let res = FetchedFData.filter((item) => item.ProposalYear == year);
      const uniqueTalukas = [...new Set(res.map((item) => item.ZillaParishad))];
      // setTaluka(uniqueTalukas);
    }
  };
  useEffect(() => {
    const fetchUsedMHUIDs = async () => {
      try {
        let res = await GetBudgetHeadInfo("null", "CheckMHUIDInWorkOrder");
        console.log("Used MHUIDs from API:", res);
        setUsedMHUIDs(Array.isArray(res) ? res : []);
      } catch (err) {
        console.log("Error fetching used MHUIDs:", err);
        setUsedMHUIDs([]);
      }
    };
    fetchUsedMHUIDs();
  }, []);

  // Re-filter TechnicalSanctionUid when usedMHUIDs or FetchedFData changes
  // useEffect(() => {
  //   if (
  //     data.talulka &&
  //     data.HeadCode &&
  //     data.ProposalYear &&
  //     usedMHUIDs.length > 0
  //   ) {
  //     sortDataByZilla(data.talulka);
  //   }
  // }, [usedMHUIDs, FetchedFData]);
  useEffect(() => {
    if (data.HeadCode && data.ProposalYear && usedMHUIDs.length >= 0) {
      if (data.WorkOrderType === "New Work Order") {
        // ✅ For New Work Order: load ALL MHUIDs (no talulka filter)
        loadAllMHUIDs();
      } else if (data.talulka) {
        sortDataByZilla(data.talulka);
      }
    }
  }, [usedMHUIDs, FetchedFData, data.WorkOrderType]);
  const sortDataByZilla = (zilla) => {
    if (data.HeadCode && data.ProposalYear) {
      let res = FetchedFData.filter(
        (item) =>
          item.ZillaParishad == zilla &&
          item.ProposalYear === data.ProposalYear,
      );

      console.log("Filtered by Zilla:", res);
      console.log("Used MHUIDs:", usedMHUIDs);

      const uniqueTechnicalData = res.reduce((acc, curr) => {
        // Check if this MHUID is already used in work order
        const isUsed = usedMHUIDs.includes(curr.TechnicalSanctionNo);

        console.log(`MHUID: ${curr.TechnicalSanctionNo}, isUsed: ${isUsed}`);

        // Only add if NOT already in array, has TechnicalSanctionNo, and NOT used
        if (
          !acc.find((item) => item.TS_ID === curr.TS_ID) &&
          curr.TechnicalSanctionNo &&
          !isUsed
        ) {
          acc.push({
            TS_ID: curr.TS_ID,
            TechnicalSanctionNo: curr.TechnicalSanctionNo,
          });
        }
        return acc;
      }, []);

      console.log("Unused MHUIDs for dropdown:", uniqueTechnicalData);
      setTechnicalSanctionUid(uniqueTechnicalData);
    }
  };
  const sortDataByGrnID = (id) => {
    console.log(id);
    if (data.HeadCode && data.ProposalYear && data.talulka) {
      let res = FetchedFData.filter(
        (item) =>
          item.GRID == id &&
          item.ZillaParishad == data.talulka &&
          item.ProposalYear === data.ProposalYear,
      );
      const uniqueProposalData = res.reduce((acc, curr) => {
        if (!acc.find((item) => item.ProposalID === curr.ProposalID)) {
          acc.push({
            ProposalID: curr.ProposalID,
            ProposalName: curr.Work_name,
            JOB_ID: curr.JOB_ID,
          });
        }
        return acc;
      }, []);
      setProposalID(uniqueProposalData);
    }
  };

  const SortProposalAmountByProposalID = async (id) => {
    console.log("proposalID", id);

    try {
      // 🚫 DON'T RUN FOR EXISTING WORK ORDER
      if (data.WorkOrderType === "Existing Work Order") {
        return;
      }

      if (data.HeadCode && data.ProposalYear && data.talulka) {
        let res1 = FetchedFData.filter((item) => item.Work_name == id);

        console.log(" Proposal Detail ----> ", res1);

        // ✅ IMPORTANT SAFETY CHECK
        if (!res1 || res1.length === 0) {
          return;
        }

        setData((prev) => ({
          ...prev,
          ProposalCost: res1[0]?.ProposalAmount || 0,
          GrID: res1[0]?.GRID || "",
          JOB_ID: res1[0]?.JOB_ID || "",
        }));

        setProposalCost(res1[0]?.TotalProposalAmount || 0);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data.ProposalId) {
      SortProposalAmountByProposalID(data.ProposalId);
    }
  }, [data.ProposalId]);

  const handleAddProposal = async() => {
    if (!data.ProposalId || !data.ProposalCost || !data.TechnicalSanctionUID) {
      alert("Please select all above fields.");
      return;
    }

    const newEntry = {
      GRID: data.GrID,
      ProposalName: data.ProposalId,
      ProposalCost: data.ProposalCost,
      RemainingProposalCost: data.RemainingProposalCost,
      TechnicalSanctionUID: data.TechnicalSanctionUID,
      JOB_ID: data.JOB_ID,
    };

    // prevent duplicates
    const alreadyAdded = selectedProposals.some(
      (p) => p.ProposalName === newEntry.ProposalName,
    );

    if (alreadyAdded) {
      alert("This Work Name is already added!");
      return;
    }
if (await hasDuplicateWorkName(newEntry.ProposalName, "New Work Order"))
      return;
    
    const updatedList = [...selectedProposals, newEntry];
    setSelectedProposals(updatedList);

    const total = updatedList.reduce(
      (sum, item) => sum + parseFloat(parseFloat(item.ProposalCost) || 0),
      0,
    );
    setTotalSelectedProposalCost(total);
    setData({
      ...data,
      ApprovedWorkAmount: total,
    });
  };

  // 🗑️ Remove proposal from table
  const handleRemoveProposal = (index) => {
    const updated = selectedProposals.filter((_, i) => i !== index);
    setSelectedProposals(updated);
    const total = updated.reduce(
      (sum, item) => sum + parseFloat(parseFloat(item.ProposalCost) || 0),
      0,
    );
    setTotalSelectedProposalCost(total);
  };

  const SortAMountsByVendor = (vendor) => {
    setData((prev) => ({
      ...prev,
      ContractorName: vendor,
    }));
  };

  const SortAMountsByWorkName = async (id) => {
    if (id.length === 1 && id[0] === " ") return;
    // console.log("dsdfsdf",id);
    try {
      if (
        data.HeadCode &&
        data.ProposalYear &&
        data.talulka &&
        data.ProposalId &&
        data.ContractorName
      ) {
        let obj = {
          ContractorName: data.ContractorName,
          ProposalID: data.ProposalId,
          WorkName: id,
        };
        let res = await GetBudgetHeadInfo(
          obj,
          "GetBillPaidRemainingWorkAmount",
        );
        const { result, status } = res;

        console.log("Data i get from Backendst :: ", res, status);

        const {
          PaidAmount,
          RemainingAmount,
          RemainingProjectAmount,
          OriginalPaidAmount,
          OriginalRemainingAmount,
        } = result[0];

        let RemainingAmountUpdated = parseFloat(RemainingAmount || 0);
        // let WorkApprovedAmountUpdate = (proposalcost - PaidAmount);

        setData({
          ...data,
          PaidAmount: PaidAmount || 0,
          // RemainingAmount: RemainingAmountUpdated,
          WorkName: id,
          // fillingForm: status,
          fillingForm: "first",

          // RemainingProposalCost: status == "first" ? (data.ProposalCost || 0) : (RemainingProjectAmount || 0),
          RemainingProposalCost: data.ProposalCost || 0,
          OriginalPaidAmount: OriginalPaidAmount || 0,
          OriginalRemainingAmount: OriginalRemainingAmount || 0,
        });

        setOriginalRemaining(RemainingAmountUpdated);
      }
    } catch (err) {
      console.log(err);
      alert(err);
    }
  };

  const SortProposalIDByMHUID = async (id) => {
    console.log("sortproposalidbymhuid :: ", id);

    try {
      if (data.HeadCode && data.ProposalYear) {
        let res1 = FetchedFData.filter(
          (item) => item.TechnicalSanctionNo == id,
        );
        console.log("Proposal ID Get from Technical UID --- > ", id, res1);

        if (res1.length > 0) {
          const workData = res1[0];

          setData((prev) => ({
            ...prev,
            TechnicalSanctionUID: id,
            ProposalId: workData.Work_name || "",
            GrID: workData.GRID || "",
            ProposalCost: workData.ProposalAmount || "0",
            talulka: workData.ZillaParishad || "",
            ulb: workData.Taluka || "",
            workClass: workData.workClass || "",
            workType: workData.workType || "",
            ContractorName: "",
            WorkName: "",
            WorkOrderDate: "",
            // WorkOrderDate: getDefaultWorkOrderDate(prev.ProposalYear),
            WorkEndDate: "",
            WorkOrderNo: "",
            RemainingProposalCost: "0",
            ApprovedWorkAmount: "0",
            PaidAmount: "0",
            CompletedProgress: "",
            RemainingAmount: "0",
            fillingForm: "second",
            OriginalRemainingAmount: "0",
            OriginalPaidAmount: "0",
            CopyOfWorkOrder: null,
          }));

          setProposalCost(workData.TotalProposalAmount || 0);
        }

        document.getElementById("CopyOfWorkOrder").value = "";
      }
    } catch (err) {
      console.log(err);
      alert(err);
    }
  };

  useEffect(() => {
    FetchData();
    FetchTalukaInfo();
  }, []);

  useEffect(() => {
    setData((prev) => {
      const approved = Number(prev.ApprovedWorkAmount || 0);
      const paid = Number(prev.PaidAmount || 0);

      return {
        ...prev,
        RemainingAmount: Math.max(approved - paid, 0),
      };
    });
  }, [data.ApprovedWorkAmount, data.PaidAmount]);

  const GetParticularTechnicalSanctionByProposal = async (proposalID) => {
    let res = await GetBudgetHeadInfo(
      proposalID,
      "GetParticularTechnicalSanctionByProposal",
    );
    console.log(
      "Data i get for GetParticularTechnicalSanctionByProposal :: ",
      res,
    );
    setTechnicalSanctionUid(res);
  };

  const FetchTalukaInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "GetTalukas");
      console.log("Data i get:: ", res);
      setUlb(res);
    } catch (err) {
      console.log(err);
    }
  };

  const processFile = (file) => {
    return new Promise(async (resolve, reject) => {
      try {
        const imageTypes = ["image/jpeg", "image/jpg", "image/png"];
        const pdfTypes = ["application/pdf"];

        // ===== IMAGE FILE =====
        if (imageTypes.includes(file.type)) {
          const exifData = await exifr.parse(file, [
            "GPSLatitude",
            "GPSLongitude",
          ]);
          if (exifData && (exifData.GPSLatitude || exifData.GPSLongitude)) {
            console.warn(
              `⚠️ EXIF GPS data found in ${file.name}. It will be stripped.`,
            );
          }

          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
              const canvas = document.createElement("canvas");
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);

              canvas.toBlob((blob) => {
                const cleanedFile = new File([blob], file.name, {
                  type: file.type,
                });
                resolve(cleanedFile);
              }, file.type);
            };

            img.onerror = reject;
            img.src = e.target.result;
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
          return;
        }

        // ===== PDF FILE =====
        if (pdfTypes.includes(file.type)) {
          const reader = new FileReader();
          reader.onload = (e) => {
            // Read as ArrayBuffer instead of text
            const arrayBuffer = e.target.result;
            const uint8Array = new Uint8Array(arrayBuffer);

            // Convert to string for pattern matching
            const textContent = new TextDecoder("latin1").decode(uint8Array);

            // More precise patterns with context
            const dangerousPatterns = [
              /\/JavaScript\s*<</, // JavaScript object definition
              /\/JS\s*\(/, // JS action with parenthesis
              /\/AA\s*<</, // Additional Actions object
              /\/OpenAction\s*<</, // OpenAction object
              /\/Launch\s*<</, // Launch action object
              /\/RichMedia\s*<</, // RichMedia object
            ];

            const isMalicious = dangerousPatterns.some((pattern) =>
              pattern.test(textContent),
            );

            if (isMalicious) {
              alert(
                `⚠️ Suspicious PDF detected in file "${file.name}". The page will reload.`,
              );

              return reject(new Error("Malicious PDF detected"));
            }

            resolve(file); // safe PDF
          };
          reader.onerror = reject;
          reader.readAsArrayBuffer(file); // Changed from readAsText
          return;
        }

        // ===== OTHER FILE TYPES =====
        resolve(file);
      } catch (error) {
        console.error("Error processing file:", error);
        reject(error);
      }
    });
  };

  // handle file input changes and process files immediately to validate / strip metadata
  const handleWorkOrderFile = async (e) => {
    // const file = e.target.files && e.target.files[0];

    const file = e.target.files[0];
    if (!file) return;

    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
      alert(validation.message);
      e.target.value = "";
      return;
    }
    if (!file) {
      setProcessedProposalCopy(null);
      return;
    }
    setFileProcessing(true);
    try {
      const cleaned = await processFile(file);
      setProcessedProposalCopy(cleaned);
    } catch (err) {
      console.error("Error processing ProposalCopy:", err);
      alert("Invalid Proposal Copy file. Please choose a different file.");
      e.target.value = "";
      setProcessedProposalCopy(null);
    } finally {
      setFileProcessing(false);
    }
  };

  // const getAdministrativeYears = () => {
  //   const startYear = 2019  ;
  //   const currentYear = new Date().getFullYear();

  //   let years = [];

  //   for (let year = startYear; year <= currentYear; year++) {
  //     years.push(`${year}-${year + 1}`);
  //   }

  //   return years;
  // };

  const getAdministrativeYears = () => {
    const isSolapur = loginDistrict === "सोलापूर" || loginDistrict?.startsWith("सोलापूर-");   //Adde New condition to check for Solapur district
    if (data.WorkOrderType === "New Work Order") {
      const startYear = 2019;
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = 2025; year <= 2026; year++) {
        years.push(`${year}-${year + 1}`);
      }
      // Solapur नसेल तर 2026-2027 काढून टाक
      // return isSolapur ? years : years.filter((y) => y !== "2026-2027");
      return years;

    } else if (data.WorkOrderType === "Existing Work Order") {
      const years = [];
      for (let year = 2019; year <= 2026; year++) {
        years.push(`${year}-${year + 1}`);
      }
      // return years;
      return isSolapur ? years : years.filter((y) => y !== "2026-2027"); // 2019-2020, 2020-2021, 2021-2022, 2022-2023, 2023-2024, 2024-2025
    }

    return [];
  };
  useEffect(() => {
    // Existing Work Order
    if (data.WorkOrderType === "Existing Work Order") {
      setData((prev) => ({
        ...prev,
        ApprovedWorkAmount: prev.ProposalCost || 0,
      }));
    }

    // New Work Order
    else if (data.WorkOrderType === "New Work Order") {
      setData((prev) => ({
        ...prev,
        ApprovedWorkAmount: TotalSelectedProposalCost || 0,
      }));
    }
  }, [data.WorkOrderType, data.ProposalCost, TotalSelectedProposalCost]);

  const loadAllMHUIDs = () => {
    if (!data.HeadCode || !data.ProposalYear) return;

    // ✅ Filter by HeadCode + ProposalYear only (no talulka for New Work Order)
    let res = FetchedFData.filter(
      (item) => item.ProposalYear === data.ProposalYear,
    );

    console.log("All FetchedFData for year:", res);
    console.log("Used MHUIDs:", usedMHUIDs);

    const uniqueTechnicalData = res.reduce((acc, curr) => {
      const isUsed = usedMHUIDs.includes(curr.TechnicalSanctionNo);

      if (
        !acc.find((item) => item.TS_ID === curr.TS_ID) &&
        curr.TechnicalSanctionNo &&
        !isUsed
      ) {
        acc.push({
          TS_ID: curr.TS_ID,
          TechnicalSanctionNo: curr.TechnicalSanctionNo,
        });
      }
      return acc;
    }, []);

    console.log("Available MHUIDs for New Work Order:", uniqueTechnicalData);
    setTechnicalSanctionUid(uniqueTechnicalData);
  };

    console.log("Fetched data:", FetchedFData);
console.log("Used MHUIDs:", usedMHUIDs);
console.log("Dropdown options:", TechnicalSanctionUid);

//////////Addded for the year
// "2020-2021" -> "2022-03-31" (end of the financial year)
const formatYMD = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const getWorkOrderMaxDate = (year) => {
  if (!year) return "";

  const startYear = parseInt(year.split("-")[0], 10);
  if (Number.isNaN(startYear)) return "";

  const maxDate = `${startYear + 2}-03-31`;
  const today = formatYMD(new Date());

  return maxDate < today ? maxDate : today;
};

// const getDefaultWorkOrderDate = (year) => {
//   if (!year) return "";
//   const endYear = Number(year.split("-")[1]);
//   if (!endYear) return "";
//   return `${endYear + 1}-03-31`;
// };
  return (
    <>
      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="col-12 m-auto my-5 budgetContainer">
          <div className="m-auto my-5 budgetElement">
            {loading && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(255, 255, 255, 0.7)",
                  backdropFilter: "blur(4px)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    border: "6px solid #f3f3f3",
                    borderTop: "6px solid #007bff",
                    borderRadius: "50%",
                    width: "60px",
                    height: "60px",
                    animation: "spin 1s linear infinite",
                  }}
                />
                <style>
                  {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                </style>
              </div>
            )}

            <div className="row px-1 mb-4 mt-3">
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="/Bill-Creation-Blue64.png"
                  alt="TechnicalSanction"
                  style={{ width: "32px", height: "32px" }}
                  className="my-auto me-2"
                />
                <h3 className="text-left fw-bold mt-2">
                  {t("Work Order Details")}
                </h3>
              </div>
              <div className="col-12 mt-4">
                <p
                  className="py-2 ps-1 fw-bold text-danger"
                  style={{ backgroundColor: "#FBE7E7" }}
                >
                  {t("Note : Fields marked with * are mandatory")}
                </p>
              </div>
            </div>

            <form action="">
              <div className="col-12 elements">
                                            {/* /////////////////// */}
  {myDepartments.length > 1 && (
  <div className="col-12 elements">
    <div className="row">
      <div className="col-5">
        <label>
          {t("Department")} <span style={{ color: "red" }}>*</span>
        </label>
      </div>
      <div className="col-7">
        <select
          name="DepartmentAccessID"
          value={data.DepartmentAccessID}
          className="py-2"
          onChange={(e) => {
            const id = e.target.value;
            // reset everything below (head code, year, works, lists)
            HandleChangeData({ target: { name: "HeadCode", value: "" } });
            setData((prev) => ({
              ...prev,
              DepartmentAccessID: id,
              ContractorName: "",
              ContractorUniqueID: "",
            }));
          }}
        >
          <option value="" disabled>{t("Select Department")}</option>
          {myDepartments.map((d) => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>
      </div>
    </div>
  </div>
)}
              {/* /////////////////// */}
              
                <div className="row">
                  <div className="col-5">
                    <label>
                      {t("Work Order Type")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>

                  <div className="col-7">
                    <select
                      name="WorkOrderType"
                      value={data.WorkOrderType}
                      className="py-2"
                      onChange={HandleChangeData}
                      style={{
                        color: data.WorkOrderType === "" ? "#999" : "#333",
                        fontWeight: "500",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <option value="" disabled>
                        {t("Select Work Order Type")}
                      </option>

                      <option value="Existing Work Order">
                        {t("Existing Work Order")}
                      </option>

                      <option value="New Work Order">
                        {t("New Work Order")}
                      </option>
                    </select>
                    {/* <select
  name="WorkOrderType"
  value={data.WorkOrderType}
  className="py-2"
  onChange={HandleChangeData}
  style={{
    color: "#333",
    fontWeight: "500",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#fff",
  }}
>
  {data.WorkOrderType === "New Work Order" ? (
    <option value="New Work Order">
      {t("New Work Order")}
    </option>
  ) : (
    <>
      <option value="" disabled>
        {t("Select Work Order Type")}
      </option>
      <option value="Existing Work Order">
        {t("Existing Work Order")}
      </option>
      <option value="New Work Order">
        {t("New Work Order")}
      </option>
    </>
  )}
</select> */}
                  </div>
                </div>
              </div>


              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">
                      {t("Head Code")} <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      name="HeadCode"
                      value={data.HeadCode}
                      id=""
                      className="py-2"
                      disabled={myDepartments.length > 1 && !data.DepartmentAccessID}
                      onChange={(e) => {
                        HandleChangeData(e);
                        FetchDataRelatedtoZilla(e.target.value, "ProjectId");
                      }}
                      style={{
                        color: data.HeadCode === "" ? "#999" : "#333",
                        fontWeight: "500",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <option value="" disabled>
                        {t("Choose Head Code")}
                      </option>
                      {/* {HeadCode &&
                        HeadCode.map((val, index) => {
                          return (
                            <option key={index} value={val.HeadID}>
                              {val.HeadName}
                            </option>
                          );
                        })} */}
                         {visibleHeadCodes.map((val, index) => (
                        <option key={index} value={val.HeadID}>
                          {val.HeadName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>
                      {t("Administrative Approved Year")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    {/* <select
                      name="ProposalYear"
                      value={data.ProposalYear}
                      id=""
                      className="py-2"
                      onChange={(e) => {
                        HandleChangeData(e);
                        setData((prev) => ({ ...prev, ProposalYear: "" }));
                        sortDatabyProposalYear(e.target.value);
                      }}
                      style={{
                        color: data.ProposalYear === "" ? "#999" : "#333",
                        fontWeight: "500",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <option value="" disabled>
                        {t("Choose Administrative Approved Year")}
                      </option>
                      {getAdministrativeYears().map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                    </select> */}
                    <select
                      name="ProposalYear"
                      value={data.ProposalYear}
                      className="py-2"
                      disabled={!data.WorkOrderType || !data.HeadCode} // disable until type and head code selected
                      onChange={(e) => {
                        const selectedYear = e.target.value;
                        HandleChangeData(e);
                        sortDatabyProposalYear(selectedYear);

                        setData((prev) => ({
                          ...prev,
                          ProposalYear: selectedYear,
                          talulka: "",
                          TechnicalSanctionUID: "",
                          ProposalId: "",
                          ContractorName: "",
                          WorkName: "",
                          WorkOrderNo: "",
                          WorkOrderDate: "",
                          // WorkOrderDate: getDefaultWorkOrderDate(selectedYear),
                          WorkEndDate: "",
                          ProposalCost: "0",
                          ApprovedWorkAmount: "0",
                          PaidAmount: "0",
                          RemainingAmount: "0",
                        }));

                        // Re-fetch data for selected HeadCode so FetchedFData is populated
                        if (data.HeadCode) {
                          FetchDataRelatedtoZilla(data.HeadCode);
                        }

                        setTechnicalSanctionUid([]);
                        setProposalID([]);
                        setSelectedProposals([]);
                        setTotalSelectedProposalCost(0);
                      }}
                    >
                      <option value="" disabled>
                        {t("Choose Administrative Approved Year")}
                      </option>
                      {getAdministrativeYears().map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>
                      {t("Current Year")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      name="CurrentYear"
                      value={data.CurrentYear}
                      id=""
                      className="py-2"
                      onChange={(e) => {
                        HandleChangeData(e);
                      }}
                      style={{
                        color: data.CurrentYear === "" ? "#999" : "#333",
                        fontWeight: "500",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <option value="" disabled>
                        {t("Choose Current Year")}
                      </option>
                      <option value="2024-2025">2024 - 2025</option>
                      <option value="2025-2026">2025 - 2026</option>
                      <option value="2026-2027">2026 - 2027</option>
                    </select>
                  </div>
                </div>
              </div> */}

              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5">
                    <label>
                      {t("Zilla Parishad")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      name="talulka"
                      value={data.talulka}
                      className="py-2"
                      onChange={(e) => {
                        HandleChangeData(e);
                        sortDataByZilla(e.target.value);
                      }}
                      style={{
                        color: data.talulka === "" ? "#999" : "#333",
                        fontWeight: "500",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <option value="" disabled>
                        {t("Select Zilla Parishad")}
                      </option>
                      {taluka &&
                        taluka.map((val, index) => {
                          return (
                            <option value={val} key={index}>
                              {val}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              </div> */}

              {data.WorkOrderType === "Existing Work Order" && (
                <>
                  {/* Technical Sanction Number */}
                  {/* <div className="col-12 elements">
        <div className="row">
          <div className="col-5">
            <label>
              {t("Technical Sanction Number")}
              <span className="text-danger">*</span>
            </label>
          </div>

          <div className="col-7">
            <input
              type="text"
              name="TechnicalSanctionUID"
              className="form-control py-2"
              placeholder="Enter Technical Sanction Number"
              value={data.TechnicalSanctionUID}
              onChange={HandleChangeData}
            />
          </div>
        </div>
      </div> */}

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5 my-auto">
                        <label className="my-auto">
                          {t("Taluka")}{" "}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        {/* // ✅ Normal dropdown for Existing Work Order */}
                        <select
                          name="ulb"
                          value={data.ulb}
                          className="py-2"
                          onChange={HandleChangeData}
                          required
                        >
                          <option value="">{t("Select Taluka")}</option>
                          {ulb &&
                            [
                              ...new Set(ulb.map((val) => val.ULBNameMarathi)),
                            ].map((ULBNameMarathi, index) => (
                              <option key={index} value={ULBNameMarathi}>
                                {ULBNameMarathi}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Class Of Work — Existing: dropdown */}
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Class Of Work")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <select
                          name="workClass"
                          value={data.workClass}
                          className="py-2"
                          onChange={HandleChangeData}
                          style={{
                            fontWeight: "500",
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <option value="" disabled>
                            {t("Choose Class Of Work")}
                          </option>
                          {WorkId &&
                            [...new Set(WorkId.map((item) => item.Work_Type))]
                              .sort()
                              .map((val, index) => (
                                <option key={index} value={val}>
                                  {val || "N/A"}
                                </option>
                              ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Type Of Work — Existing: dropdown */}
                  {/* <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Type of Work")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <select
                          name="workType"
                          value={data.workType}
                          className="py-2"
                          onChange={HandleChangeData}
                          style={{
                            fontWeight: "500",
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <option value="" disabled>
                            {t("Choose Type of Work")}
                          </option>
                          {getWork &&
                            getWork.map((val, index) => (
                              <option key={index} value={val.Work_name}>
                                {val.Work_name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div> */}

                  {/* Work Name */}
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Work Name")}
                          <span className="text-danger">*</span>
                        </label>
                      </div>

                      <div className="col-7">
                        <input
                          type="text"
                          name="ProposalId"
                          className="form-control py-2"
                          placeholder="Enter Work Name"
                          value={data.ProposalId}
                          // onChange={HandleChangeData}
                          onChange={(e) => {
                            let value = e.target.value
                              .replace(
                                /[^0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g,
                                "",
                              )
                              .replace(/^\s+/, "");

                            HandleChangeData({
                              target: {
                                name: e.target.name,
                                value: value,
                              },
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Work Cost */}
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Work Cost")}
                          <span className="text-danger">*</span>
                        </label>
                      </div>

                      <div className="col-7">
                        <input
                          type="number"
                          name="ProposalCost"
                          className="form-control py-2"
                          placeholder="Enter Work Cost"
                          value={data.ProposalCost}
                          onChange={HandleChangeData}
                          onFocus={() => {
                            if (data.ProposalCost === "0") {
                              setData((prev) => ({
                                ...prev,
                                ProposalCost: "",
                              }));
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data.WorkOrderType === "New Work Order" && (
                <>
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("MHUID Number")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <Select
                          options={
                            TechnicalSanctionUid?.map((val) => ({
                              value: val.TechnicalSanctionNo,
                              label: val.TechnicalSanctionNo,
                            })) || []
                          }
                          value={
                            data.TechnicalSanctionUID
                              ? {
                                  value: data.TechnicalSanctionUID,
                                  label: data.TechnicalSanctionUID,
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const value = selectedOption?.value || "";

                            HandleChangeData({
                              target: {
                                name: "TechnicalSanctionUID",
                                value,
                              },
                            });

                            SortProposalIDByMHUID(value);
                          }}
                          placeholder={t("Search MHUID Number")}
                          isSearchable
                          className="basic-single"
                          classNamePrefix="select"
                          noOptionsMessage={() => "No MHUID Found"}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5 my-auto">
                        <label className="my-auto">
                          {t("Taluka")}{" "}
                          <span className="text-danger fw-bold">*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        {/* // ✅ Auto-filled + disabled for New Work Order */}
                        <input
                          type="text"
                          className="form-control py-2"
                          value={data.ulb || ""}
                          readOnly
                          disabled
                          placeholder={t("Auto-filled from MHUID")}
                          style={{
                            backgroundColor: "#f0f0f0",
                            color: "#555",
                            fontWeight: "500",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            cursor: "not-allowed",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Class Of Work — New: auto-filled + disabled */}
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Class Of Work")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          className="form-control py-2"
                          value={data.workClass || ""}
                          readOnly
                          disabled
                          placeholder={t("Auto-filled from MHUID")}
                          style={{
                            backgroundColor: "#f0f0f0",
                            color: "#555",
                            fontWeight: "500",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            cursor: "not-allowed",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Type Of Work — New: auto-filled + disabled */}
                  {/* <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Type of Work")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          className="form-control py-2"
                          value={data.workType || ""}
                          readOnly
                          disabled
                          placeholder={t("Auto-filled from MHUID")}
                          style={{
                            backgroundColor: "#f0f0f0",
                            color: "#555",
                            fontWeight: "500",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            cursor: "not-allowed",
                          }}
                        />
                      </div>
                    </div>
                  </div> */}

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>
                          {t("Work Name")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>

                      <div className="col-7">
                        <input
                          type="text"
                          name="ProposalId"
                          value={data.ProposalId}
                          className="form-control py-2"
                          placeholder={t("Work Name Auto Fetch")}
                          readOnly
                          style={{
                            backgroundColor: "#f5f5f5",
                            color: "#333",
                            fontWeight: "500",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5"></div>
                      <div className="col-7">
                        <button
                          type="button"
                          className="btn btn-success px-4 py-1"
                          onClick={handleAddProposal}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <img
                            src="/Added-Work-Names64.png"
                            alt="Add"
                            style={{ width: "14px", height: "14px" }}
                          />
                          {t("Add Works")}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* 🧮 NEW TABLE SECTION */}
                  {selectedProposals.length > 0 && (
                    <div className="col-12 mt-4">
                      <h5 className="fw-bold mb-2">{t("Added Works")}</h5>
                      <div
                        className="col-12 tableDesign"
                        style={{
                          background: "#0098d5",
                          borderRadius: "10px 10px 0 0",
                        }}
                      >
                        <table
                          className="m-0 p-0"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                color: "white",
                                height: "3rem",
                                fontSize: "13px",
                              }}
                            >
                              <th>Sr.No.</th>
                              <th>{t("Work Name")}</th>
                              <th>{t("Job ID")}</th>
                              <th>{t("Work Cost")}</th>
                              {/* <th>{t("Remaining Proposal Work Cost")}</th> */}
                              <th>{t("Technical Sanction Number")}</th>
                              <th>{t("Action")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedProposals.map((p, i) => {
                              const bgColor =
                                i % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  key={i}
                                  style={{ backgroundColor: bgColor }}
                                >
                                  <td>{i + 1}</td>
                                  <td>{p.ProposalName}</td>
                                  <td>{p.JOB_ID}</td>
                                  <td>{p.ProposalCost}</td>
                                  {/* <td>{p.RemainingProposalCost}</td> */}
                                  <td>{p.TechnicalSanctionUID}</td>
                                  <td>
                                    <button
                                      className="btn btn-danger btn-sm mx-auto"
                                      onClick={() => handleRemoveProposal(i)}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <img
                                        src="/Remove-64.png"
                                        alt="Remove"
                                        style={{
                                          width: "14px",
                                          height: "14px",
                                        }}
                                      />
                                      {t("Remove")}
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* --> Old code */}
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">
                      {t("Vendor Name")} <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      name="ContractorName"
                      value={data.ContractorName}
                      className="form-select py-2"
                      onChange={HandleChangeData}
                      style={{
                        color: data.Bidder_CompanyName === "" ? "#999" : "#333",
                        fontWeight: "500",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <option value="">{t("Choose Vendor")}</option>
                      {Contractor &&
                        Contractor.map((val, index) => {
                          return (
                            <option key={index} value={val.Bidder_CompanyName}>
                              {val.Bidder_CompanyName}
                              {" - "}
                              {val.Account_Number}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              </div> */}

              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">
                      {t("Vendor Name")} <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      name="ContractorUniqueID"
                      value={data.ContractorUniqueID}
                      className="form-select py-2"
                      onChange={(e) => {
                        const selectedID = e.target.value;
                        const matchedVendor = Contractor.find(
                          (v) => String(v.UniqueID) === String(selectedID),
                        );
                        setData((prev) => ({
                          ...prev,
                          ContractorUniqueID: selectedID,
                          ContractorName:
                            matchedVendor?.Bidder_CompanyName || "",
                        }));
                      }}
                      style={{
                        color: data.Bidder_CompanyName === "" ? "#999" : "#333",
                        fontWeight: "500",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <option value="">{t("Choose Vendor")}</option>
                      {Contractor &&
                        Contractor.map((val, index) => (
                          <option key={index} value={val.UniqueID}>
                            {val.Bidder_CompanyName} - {val.Account_Number}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div> */}

              {/* //////Addded new for department wise */}
                            <div className="col-12 elements">
  <div className="row">
    <div className="col-5 my-auto ">
      <label className="my-auto">
        {t("Vendor Name")} <span style={{ color: "red" }}>*</span>
      </label>
    </div>
    <div className="col-7">
      <select
        name="ContractorUniqueID"
        value={data.ContractorUniqueID}
        className="form-select py-2"
        onChange={(e) => {
          const selectedID = e.target.value;
          const matchedVendor = visibleContractors.find(
            (v) => String(v.UniqueID) === String(selectedID),
          );
          setData((prev) => ({
            ...prev,
            ContractorUniqueID: selectedID,
            ContractorName: matchedVendor?.Bidder_CompanyName || "",
          }));
        }}
        style={{
          color: data.ContractorUniqueID === "" ? "#999" : "#333",
          fontWeight: "500",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          backgroundColor: "#fff",
        }}
      >
        <option value="">{t("Choose Vendor")}</option>
        {visibleContractors.map((val, index) => (
          <option key={index} value={val.UniqueID}>
            {val.Bidder_CompanyName} - {val.Account_Number}
          </option>
        ))}
      </select>
    </div>
  </div>
</div>

              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">
                      {t("Work Order Name")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      placeholder={t("Enter Work Order Name")}
                      className="form-control py-2"
                      name="WorkName"
                      value={data.WorkName}
                      onChange={(e) => {
                        let value = e.target.value
                          .replace(
                            /[^a-zA-Z0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g,
                            "",
                          )
                          .replace(/^\s+/, "");
                        HandleChangeData({
                          target: { name: "WorkName", value },
                        });
                        SortAMountsByWorkName(e.target.value);
                      }}
                      onBlur={(e) => {
                        const value = e.target.value.trim();

                        // Check if at least ONE valid character exists
                        const hasValidChar = /[a-zA-Z0-9\u0900-\u097F]/.test(
                          value,
                        );
                        if (value && !hasValidChar) {
                          setError("Enter at least one valid character");
                          alert("Enter at least one valid character");
                          setTimeout(() => e.target.focus(), 0);
                        } else {
                          setError("");
                        }
                      }}
                    />
                  </div>
                </div>
              </div> */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">
                      {t("Work Order Number")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      placeholder={t("Enter Work Order Number")}
                      className="form-control py-2"
                      name="WorkOrderNo"
                      value={data.WorkOrderNo}
                      onChange={(e) => {
                        let value = e.target.value
                          .replace(
                            /[^a-zA-Z0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g,
                            "",
                          )
                          .replace(/^\s+/, "");
                        HandleChangeData({
                          target: { name: "WorkOrderNo", value },
                        });
                      }}
                      onBlur={(e) => {
                        const value = e.target.value.trim();

                        // Check if at least ONE valid character exists
                        const hasValidChar = /[a-zA-Z0-9\u0900-\u097F]/.test(
                          value,
                        );
                        if (value && !hasValidChar) {
                          setError("Enter at least one valid character");
                          alert("Enter at least one valid character");
                          setTimeout(() => e.target.focus(), 0);
                        } else {
                          setError("");
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>
                      {t("Work Order Date")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    {/* <input
                      type="date"
                      placeholder={t("Enter Work Order Date")}
                      className="form-control py-2"
                      value={data.WorkOrderDate}
                      name="WorkOrderDate"
                      onChange={HandleChangeData}
                      onKeyDown={(e) => e.preventDefault()}
                      // max={new Date().toLocaleDateString("en-CA")}
                      max={
                        data.ProposalYear
                          ? getDefaultWorkOrderDate(data.ProposalYear)
                          : new Date().toLocaleDateString("en-CA")
                      }
                    /> */}
<input
  ref={workOrderDateRef}
  type="date"
  className="form-control py-2"
  name="WorkOrderDate"
  value={data.WorkOrderDate || ""}
  max={getWorkOrderMaxDate(data.ProposalYear)}
  disabled={!data.ProposalYear}
  onChange={(e) => {
    const value = e.target.value;

    if (
      value &&
      value > getWorkOrderMaxDate(data.ProposalYear)
    ) {
      alert("Please select a valid Work Order Date.");
      return;
    }

    HandleChangeData(e);
  }}
/>

  {/* <FYDatePicker
  name="WorkOrderDate"
  value={data.WorkOrderDate}
  onPick={(name, value) => HandleChangeData({ target: { name, value } })}
  minDate={fyStartDate}
  maxDate={fyMaxDate}
  openToDate={fyStartDate}
  disabled={!data.ProposalYear}
/> */}
                  </div>
                </div>
              </div>
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>
                      {t("Work Order End Date")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="date"
                      placeholder={t("Enter Work Order End Date")}
                      className="form-control py-2"
                      value={data.WorkEndDate}
                      name="WorkEndDate"
                      onChange={HandleChangeData}
                      onKeyDown={(e) => e.preventDefault()}
                      min={data.WorkOrderDate}
                      // max={new Date().toLocaleDateString("en-CA")}
                    />
                  </div>
                </div>
              </div>

              {data.WorkOrderType === "Existing Work Order" && (
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-5  ">
                      <label>
                        {t("Administrative Approved GR Date")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                    <div className="col-7">
                      <input
                        type="date"
                        placeholder={t("Enter Administrative Approved GR Date")}
                        className="form-control py-2"
                        value={data.workApprovedGRDate}
                        name="workApprovedGRDate"
                        onChange={HandleChangeData}
                        onKeyDown={(e) => e.preventDefault()}
                        max={data.WorkOrderDate}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>
                      {t("Total Work Cost")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      placeholder={t("Enter Work End Date")}
                      className="form-control py-2"
                      value={
                        data.WorkOrderType === "Existing Work Order"
                          ? data.ProposalCost || 0
                          : TotalSelectedProposalCost
                      }
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">
                      {t("Approved Work Order Amount")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="number"
                      placeholder={t("Enter Approved Work Order Amount")}
                      className="form-control py-2"
                      name="ApprovedWorkAmount"
                      value={data.ApprovedWorkAmount}
                      onChange={HandleChangeData}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">
                      {t("Completed Progress")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      value={data.CompletedProgress}
                      style={{
                        color: data.CompletedProgress === "" ? "#999" : "#333",
                        fontWeight: "500",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                      disabled
                    >
                      <option value="NA">NA</option>
                      <option value="30">30%</option>
                      <option value="50">50%</option>
                      <option value="100">100%</option>
                    </select>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">{t("Paid Amount")}</label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text" // Changed to text to support the regex cleaning safely
                      placeholder={t("Enter Paid Amount")}
                      className="form-control py-2"
                      name="PaidAmount"
                      value={data.PaidAmount}
                      // Disable if ApprovedWorkAmount isn't set yet
                      disabled={!data.ApprovedWorkAmount || data.ApprovedWorkAmount === "0"}
                      onChange={(e) => {
                        let val = e.target.value
                          .replace(/[^0-9]/g, "") // Simplified: only digits
                          .replace(/^\s+/, "");

                        HandleChangeData({
                          target: { name: "PaidAmount", value: val },
                        });
                      }}
                    />
                  </div>
                </div>
              </div> */}
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className="my-auto">
                      {t("Remaining Amount")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      placeholder={t("Enter Remaining Amount")}
                      className="form-control py-2"
                      name='RemainingAmount'
                      value={data.RemainingAmount}
                      onChange={HandleChangeData}
                      disabled
                    />
                  </div>
                </div>
              </div> */}

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>
                      {t("Copy of Work Order")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="file"
                      className="form-control py-2"
                      accept=".pdf,.jpg,.jpeg,.png"
                      id="CopyOfWorkOrder"
                      //  ref={CopyOfWorkOrder}
                      onChange={handleWorkOrderFile}
                    />
                    {/* {processedProposalCopy && (
                                            <div style={{ fontSize: 12, marginTop: 6 }}>
                                                {t("Selected")}: {processedProposalCopy.name}
                                            </div>
                                        )} */}
                  </div>
                </div>
              </div>
              <div className="col-12 ms-auto my-4">
                <div className="row">
                  <div className="col-5"></div>
                  <div className="col-7">
                    <div className="col-12">
                      <button
                        type="button"
                        disabled={
                          loading || fileProcessing || isSubmittingRef.current
                        }
                        className="px-4 py-1 btn btn-primary"
                        onClick={handleSubmit}
                        style={{
                          cursor: loading ? "not-allowed" : "pointer",
                          opacity: loading ? 0.7 : 1,
                        }}
                      >
                        {loading ? "Saving..." : t("Save")}
                      </button>
                      <button className="px-4 py-1 btn btn-danger mx-4">
                        {t("Cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default CreateWorkOrder;
